<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-4 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">
            {{ $route.meta.title }}
          </h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-8 text-right">
          <div class="box-buttons">
            <base-button
              v-if="canUserUpdate && customer.type === 'travel_access'"
              type="outline-neutral"
              class="min-button no-mb mr-2"
              @click="openModalChange()"
            >
              <i class="flaticon-support icon-no-margin"></i>
              <strong class="d-lg-block d-none">Change to Partner</strong>
            </base-button>

            <base-dropdown
              v-if="canUserResendEmail"
              menu-on-right
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral mr-2"
              title="Actions"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-send"></i>

                <strong class="d-lg-block d-none">Send Email</strong>
              </base-button>

              <div
                class="dropdown-item"
                @click="sendConfirmation()"
                v-if="!customer.status && customerStatus"
              >
                To confirm Account
              </div>
              <div class="dropdown-item" @click="sendEmailPassword()">
                To password recover
              </div>
            </base-dropdown>

            <base-button
              type="outline-neutral"
              class="min-button mr-2 no-mb"
              @click="mode = 'view'"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              v-if="canUserUpdate && mode === 'view'"
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button no-mb mr-2"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              v-if="canUserUpdate && mode === 'edit'"
              type="primary"
              @click="savePartner()"
              class="min-button no-mb"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid profile mb-5 forms">
      <div class="row">
        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row justify-content-center">
            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card">
                <div class="row justify-content-center">
                  <div class="col-lg-12 col-md-12 text-center pb-1">
                    <div
                      class="d-inline-block mb-3"
                      v-if="!customer.approve && !loadingData"
                    >
                      <div class="badge-profile status-cancelled">
                        <i
                          class="flaticon-traffic-signal text-danger f25 mr-2"
                        ></i>
                        <span>Pending Approval</span>
                      </div>
                    </div>

                    <label
                      for="driver_ProfileImage"
                      class="title-label-np mb-2"
                      v-if="mode === 'edit'"
                    >
                      Profile Image
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <ul class="ul-pop">
                          <li>Allowed Dimensions: 500px x 500px</li>
                          <li>Maximum Size: 2MB</li>
                          <li>Allowed Formats: gif, jpg, jpeg, png</li>
                        </ul>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>

                    <div class="imageload3">
                      <div class="image">
                        <div
                          v-if="customer.url_picture"
                          v-bind:style="{
                            backgroundImage: 'url(' + customer.url_picture + ')'
                          }"
                          class="imgprofile"
                        ></div>

                        <div
                          v-else
                          v-bind:style="{
                            backgroundImage: 'url(' + imageProfile + ')'
                          }"
                          class="imgprofile"
                        ></div>
                      </div>

                      <div class="contentfile3" v-if="mode === 'edit'">
                        <base-dropdown>
                          <base-button
                            slot="title-container"
                            type="primary"
                            class="dropdown-toggle btn-icon-only buttonfiles3"
                          >
                            <i class="flaticon-camera mr-0"></i>
                          </base-button>
                          <span class="dropdown-item">
                            <base-input
                              class="filebutton3"
                              type="file"
                              name="file-1"
                              id="file-1"
                              :accesskey="'profile'"
                              enctype="multipart/form-data"
                              accept="image/jpeg, image/jpg, image/png"
                              @change="readFile"
                            ></base-input>
                            Upload Image
                          </span>
                          <span
                            class="dropdown-item"
                            v-if="picture"
                            @click="clearfile()"
                            >Remove
                          </span>
                        </base-dropdown>
                      </div>
                    </div>

                    <div class="box-profile-one">
                      <h2
                        class="subtitle mb-1"
                        v-if="customer.type === 'travel_agency'"
                      >
                        {{ customer.company_name }}
                      </h2>
                      <h2 class="subtitle mb-1" v-else>
                        {{ customer.first_name }}
                        {{ customer.last_name }}
                      </h2>

                      <div class="role mb-0">
                        {{ getUserType(customer.type) }}
                      </div>
                    </div>

                    <div class="d-inline-block mt-2 mb-3">
                      <div
                        class="badge-profile status-confirmed"
                        v-if="customer.status && customerStatus"
                      >
                        <i class="flaticon-check-2 text-success f25 mr-2"></i>
                        <span>Confirmed</span>
                      </div>

                      <div
                        class="badge-profile status-cancelled"
                        v-if="!customer.status && customerStatus"
                      >
                        <i class="flaticon-check-2 text-danger f25 mr-2"></i>
                        <span>No Confirmed</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
              v-if="partnerType === 'travel_agency'"
            >
              <div
                class="card"
                v-if="mode === 'view' && customer.credit.status"
              >
                <h2 class="subtitle">Credit</h2>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Available</span>
                          <span class="content-block"
                            >{{ customer.currency.symbol }}
                            {{ customer.credit.available }}
                            {{ customer.currency.code }}
                          </span>
                        </div>
                      </div>

                      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Pending Payment</span>
                          <span
                            class="content-block"
                            :class="{ 'text-danger': pendingPayment > 0 }"
                          >
                            {{ customer.currency.symbol }}
                            {{ pendingPayment }}
                            {{ customer.currency.code }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="card"
                v-if="mode === 'edit' && partnerType === 'travel_agency'"
              >
                <h2 class="subtitle">Credit</h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-2 col-md-12 col-sm-3 col-12 switch-md mb-2"
                  >
                    <base-switch
                      onText="Yes"
                      offText="No"
                      class="sw-md"
                      v-model="customer.credit.status"
                      tabindex="20"
                      @input="changeStatusCredit"
                    ></base-switch>
                  </div>

                  <div
                    class="col-xl-12 col-lg-5 col-md-6 col-sm-4 col-12"
                    v-if="customer.credit.status"
                  >
                    <BaseNumberInput
                      v-model.number="$v.customer.credit.limit.$model"
                      label="Credit limit"
                      placeholder="Credit limit"
                      id="limit_credit"
                      name="limit_credit"
                      maxlength="6"
                      tabindex="21"
                      format="capitalize"
                      class="input-append with-prepend"
                      @input="changeLimit"
                      markrequired
                      :error="
                        $v.customer.credit.limit.$error
                          ? `Enter a limit credit`
                          : ''
                      "
                    >
                      <template slot="prepend">{{
                        customer.currency.symbol
                      }}</template>
                      <template slot="append">{{
                        customer.currency.code
                      }}</template>
                    </BaseNumberInput>
                  </div>
                  <div
                    class="col-xl-12 col-lg-5 col-md-6 col-sm-4 col-12"
                    v-if="customer.credit.status"
                  >
                    <BaseNumberInput
                      v-model.number="customer.credit.available"
                      label="Available Credit"
                      placeholder="Available Credit"
                      id="available_credit"
                      name="available_credit"
                      readonly
                      maxlength="45"
                      tabindex="22"
                      class="input-append with-prepend"
                      disabled
                    >
                      <template slot="prepend">{{
                        customer.currency.symbol
                      }}</template>
                      <template slot="append">{{
                        customer.currency.code
                      }}</template>
                    </BaseNumberInput>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card">
                <h2 class="subtitle">Notes</h2>
                <div class="row">
                  <div class="col-12">
                    <div class="data-block" v-if="mode === 'view'">
                      <span class="content-block" v-if="customer.notes">{{
                        customer.notes
                      }}</span>
                      <span class="content-block" v-else>No notes here</span>
                    </div>

                    <div class="mb-4" v-if="mode === 'edit'">
                      <el-input
                        v-model="$v.customer.notes.$model"
                        placeholder="notes"
                        id="customer_notes"
                        name="customer_notes"
                        tabindex="23"
                        maxlength="200"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 10 }"
                        show-word-limit
                      >
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-lg-12 col-md-12">
          <tabs
            tabNavClasses="tabs-home justify-content-around tab-profiles"
            :value="tabActive"
            @changeTabActive="changeTabActive"
          >
            <tab-pane id="Overview" title="Overview" ref="Overview">
              <div class="card">
                <h2 class="subtitle">Business Details</h2>
                <div
                  v-if="mode === 'view' && customer.type === 'travel_agency'"
                >
                  <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                      <div class="data-block">
                        <span class="title-block">Agency Name</span>
                        <span class="content-block">{{
                          customer.company_name
                        }}</span>
                      </div>
                    </div>

                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12"
                      v-if="customer.legal_name"
                    >
                      <div class="data-block">
                        <span class="title-block">Legal Business Name</span>
                        <span class="content-block">{{
                          customer.legal_name
                        }}</span>
                      </div>
                    </div>

                    <div
                      class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-12"
                      v-if="customer.iata_code"
                    >
                      <div class="data-block">
                        <span class="title-block">IATA Code</span>
                        <span class="content-block">{{
                          customer.iata_code
                        }}</span>
                      </div>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12"
                      v-if="customer.vat_number"
                    >
                      <div class="data-block">
                        <span class="title-block">VAT Number</span>
                        <span class="content-block">{{
                          customer.vat_number
                        }}</span>
                      </div>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
                      <div class="data-block">
                        <span class="title-block">Managed Account</span>
                        <span class="content-block">{{
                          customer.managed_account ? "Yes" : "No"
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="row mt-2"
                  v-if="mode === 'edit' && customer.type === 'travel_agency'"
                >
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.company_name.$model"
                          label="Agency Name"
                          placeholder="Agency Name"
                          id="bussiness_name"
                          name="bussiness_name"
                          tabindex="1"
                          maxlength="45"
                          @input="changeCompanyName"
                          markrequired
                          :error="
                            !$v.customer.company_name.minLength ||
                            $v.customer.company_name.$error
                              ? `Enter from ${$v.customer.company_name.$params.minLength.min} to ${$v.customer.company_name.$params.maxLength.max} letters`
                              : ''
                          "
                        />
                      </div>

                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.legal_name.$model"
                          label="Legal Name"
                          placeholder="Legal Name"
                          id="bussiness_Legalname"
                          name="bussiness_Legalname"
                          tabindex="2"
                          maxlength="45"
                          :error="
                            !$v.customer.legal_name.minLength ||
                            $v.customer.legal_name.$error
                              ? `Enter from ${$v.customer.legal_name.$params.minLength.min} to ${$v.customer.legal_name.$params.maxLength.max} letters`
                              : ''
                          "
                        />
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.iata_code.$model"
                          label="IATA Code"
                          placeholder="IATA Code"
                          id="bussiness_iata_code"
                          name="bussiness_iata_code"
                          tabindex="2"
                          maxlength="45"
                          :error="
                            $v.customer.iata_code.$error
                              ? `Enter from ${$v.customer.iata_code.$params.minLength.min} to ${$v.customer.iata_code.$params.maxLength.max} characters`
                              : ''
                          "
                        />
                      </div>
                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.vat_number.$model"
                          label="VAT Number"
                          placeholder="VAT Number"
                          id="bussiness_VatNumber"
                          name="bussiness_VatNumber"
                          tabindex="2"
                          maxlength="45"
                          @input="changeVATNumber"
                          :error="
                            $v.customer.vat_number.$error
                              ? `Enter from ${$v.customer.vat_number.$params.minLength.min} to ${$v.customer.vat_number.$params.maxLength.max} characters`
                              : ''
                          "
                        />
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <label class="title-label"
                          >Managed Account
                          <el-popover
                            placement="top"
                            trigger="hover"
                            width="300"
                            class="curp"
                          >
                            <span>
                              Activate this option if the account is
                              administered and/or managed by a Travel Agency
                            </span>
                            <div class="badge badge-primary" slot="reference">
                              ?
                            </div>
                          </el-popover></label
                        >
                        <base-switch
                          v-model="customer.managed_account"
                          class="sw-md mt-2 ml-3"
                        ></base-switch>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="row"
                  v-if="mode === 'view' && customer.type === 'travel_access'"
                >
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Partner Agency</span>
                          <span class="content-block" v-if="association">{{
                            association.company_name
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="row mt-2"
                  v-if="mode === 'edit' && customer.type === 'travel_access'"
                >
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <WSelect
                          v-bind:class="{
                            'invalid-feedback': $v.customer.association.$error
                          }"
                          v-model="$v.customer.association.$model"
                          label="Partner agency"
                          disabled
                          placeholder="Select an Agency Name"
                          id="agency_name"
                          name="agency_name"
                          tabindex="3"
                          remote
                          filterable
                          reserve-keyword
                          clearable
                          markrequired
                          :error="
                            $v.customer.association.$error
                              ? `Select an Agency`
                              : ''
                          "
                        >
                          <el-option
                            v-for="(agency, index) in agencies"
                            :value="agency._id"
                            :label="agency.company_name"
                            :key="index"
                          ></el-option>
                        </WSelect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle">Main Contact</h2>

                <div v-if="mode === 'view'">
                  <div class="row">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                      <div class="data-block">
                        <span class="title-block">Full Name</span>
                        <span class="content-block"
                          >{{ customer.first_name }}
                          {{ customer.last_name }}</span
                        >
                      </div>
                    </div>
                    <div
                      class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12"
                      v-if="customer.gender"
                    >
                      <div class="data-block">
                        <span class="title-block">Gender</span>
                        <span class="content-block">{{
                          getGender(customer.gender)
                        }}</span>
                      </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
                      <div class="data-block">
                        <span class="title-block">Contact Number</span>
                        <span class="content-block">
                          <a :href="`tel:${customer.phone}`">{{
                            customer.phone
                          }}</a>
                          <el-tooltip content="Copy" placement="bottom">
                            <span
                              class="curp ml-2"
                              v-clipboard:copy="customer.phone"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onErrorCopy"
                            >
                              <i class="flaticon-copy link ml-0"></i></span
                          ></el-tooltip>
                        </span>
                      </div>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12"
                      v-if="customer.contact_info"
                    >
                      <div class="data-block">
                        <span class="title-block">Other Contact Info</span>
                        <span class="content-block">
                          <i
                            class="flaticon-bold-whatsapp f16 mr-1"
                            v-if="
                              customer.other_contact_platform === 'Whatsapp'
                            "
                          ></i>
                          <i
                            class="flaticon-bold-logotipo-de-skype f16 mr-1"
                            v-if="customer.other_contact_platform === 'Skype'"
                          ></i>

                          {{ customer.contact_info }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-12 mt-2" v-if="mode === 'edit'">
                  <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                      <base-input
                        v-model.trim="$v.customer.first_name.$model"
                        label="First Name"
                        placeholder="First Name"
                        id="first_name"
                        name="first_name"
                        maxlength="45"
                        tabindex="1"
                        format="capitalize"
                        :focusact="true"
                        markrequired
                        :error="
                          !$v.customer.first_name.minLength ||
                          $v.customer.first_name.$error
                            ? `Enter from ${$v.customer.first_name.$params.minLength.min} to ${$v.customer.first_name.$params.maxLength.max} letters`
                            : ''
                        "
                      />
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                      <base-input
                        v-model.trim="$v.customer.last_name.$model"
                        label="Last Name"
                        placeholder="Last Name"
                        id="last_name"
                        name="last_name"
                        maxlength="45"
                        tabindex="2"
                        format="capitalize"
                        markrequired
                        :error="
                          !$v.customer.last_name.minLength ||
                          $v.customer.last_name.$error
                            ? `Enter from ${$v.customer.last_name.$params.minLength.min} to ${$v.customer.last_name.$params.maxLength.max} letters`
                            : ''
                        "
                      />
                    </div>
                    <div
                      class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12 form-group"
                      v-bind:class="{
                        'is-invalid': $v.customer.gender.$error
                      }"
                    >
                      <label for="title" class="title-label">Gender</label>
                      <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                        <b-form-radio-group
                          v-model="$v.customer.gender.$model"
                          :aria-describedby="ariaDescribedby"
                          id="radio-gender"
                          name="radio-gender"
                          buttons
                          button-variant="outline-neutral"
                          size="md"
                          tabindex="3"
                        >
                          <b-form-radio value="male" class="pc-3" tabindex="3"
                            >Mr.</b-form-radio
                          >
                          <b-form-radio value="female" class="pc-3"
                            >Mrs.</b-form-radio
                          >
                          <b-form-radio value="other" class="pc-3"
                            >Mx.</b-form-radio
                          >
                        </b-form-radio-group>
                      </b-form-group>

                      <small
                        class="invalid-feedback mt-1"
                        v-if="$v.customer.gender.$error"
                        >Select</small
                      >
                    </div>

                    <div
                      class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 inputphone form-group"
                    >
                      <label
                        class="title-label"
                        v-bind:class="{
                          'is-invalid': $v.customer.phone.$error
                        }"
                        ><span class="markrequired">*</span>Contact
                        Number</label
                      >
                      <vue-tel-input
                        v-model="phoneFormat"
                        key="NumberPhoneCustomer"
                        inputId="NumberPhoneCustomer"
                        name="NumberPhoneCustomer"
                        required
                        mode="international"
                        inputClasses="input no-label no-err"
                        :dynamicPlaceholder="true"
                        :disabledFetchingCountry="true"
                        :validCharactersOnly="true"
                        :wrapperClasses="[
                          $v.customer.phone.$error ? 'is-invalid' : '',
                          'mb-0'
                        ]"
                        @validate="phoneInput"
                        tabindex="6"
                      ></vue-tel-input>
                      <small
                        class="invalid-feedback mt-1"
                        v-if="$v.customer.phone.$error"
                        >Enter a valid Phone Number</small
                      >
                    </div>

                    <div class="col-xl-5 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label class="title-label">Other Contact Info</label>
                      <div class="d-flex">
                        <b-form-group
                          v-slot="{ ariaDescribedby2 }"
                          class="d-inline-flex"
                        >
                          <b-form-radio-group
                            v-model="customer.other_contact_platform"
                            :aria-describedby="ariaDescribedby2"
                            id="radio-contact"
                            name="radio-contact"
                            tabindex="7"
                            buttons
                            button-variant="outline-neutral"
                            size="md"
                          >
                            <b-form-radio
                              value="Whatsapp"
                              class="pc-2"
                              title="Whatsapp"
                              tabindex="7"
                              ><i class="flaticon-bold-whatsapp f16"></i
                            ></b-form-radio>
                            <b-form-radio
                              value="Skype"
                              class="pc-2"
                              title="Skype"
                              ><i
                                class="flaticon-bold-logotipo-de-skype f16"
                              ></i
                            ></b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>

                        <base-input
                          v-model.trim="customer.contact_info"
                          placeholder="Other Contact Info"
                          id="passengers_phone_optional"
                          name="passengers_phone_optional"
                          tabindex="8"
                          class="d-inline-flex"
                        >
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle">Account Info</h2>
                <div class="row" v-show="mode === 'view'">
                  <div class="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Email Address</span>
                      <span class="content-block">
                        <a
                          :href="
                            `https://mail.google.com/mail/?view=cm&fs=1&to=${customer.email}`
                          "
                          target="_blank"
                          >{{ customer.email }}</a
                        >
                        <el-tooltip content="Copy" placement="bottom">
                          <span
                            class="curp ml-2"
                            v-clipboard:copy="customer.email"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onErrorCopy"
                          >
                            <i class="flaticon-copy link ml-0"></i></span
                        ></el-tooltip>
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Register Source</span>
                      <span class="content-block">{{ source }}</span>
                    </div>
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Register Date/Time</span>
                      <span class="content-block">{{ created }}</span>
                    </div>
                  </div>
                </div>

                <div class="row mt-2" v-show="mode === 'edit'">
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                        <base-input
                          label="Email Address"
                          placeholder="Email Address"
                          id="customer_email"
                          name="customer_email"
                          maxlength="100"
                          tabindex="14"
                          format="lowercase"
                          autocomplete="off"
                          v-model.trim="$v.customer.email.$model"
                          @input="changeCompanyEmail"
                          markrequired
                          :error="getEmailValidationMessage($v.customer.email)"
                        />
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Register Source</span>
                          <span class="content-block">{{ source }}</span>
                        </div>
                      </div>

                      <div class="col-xl-4 col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Register Date/Time</span>
                          <span class="content-block">{{ created }}</span>
                        </div>
                      </div>

                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                        <base-input
                          v-model="$v.customer.password.$model"
                          label="Password"
                          placeholder="Password"
                          name="password"
                          id="password"
                          :type="typePassword"
                          autocomplete="new-password"
                          maxlength="20"
                          tabindex="15"
                          class="input-append mb-0"
                          markrequired
                          :tooltip="true"
                          titleTooltip='<i class="flaticon-lock mr-2"></i><strong>Strong Password</strong>'
                          contentTooltip='<ul class="ul-pop">
                                  <li>Enter from 8 characters</li>
                                  <li>1 Uppercase Letter</li>
                                  <li>1 Lowercase Letter</li>
                                  <li>1 Number</li>
                                  <li>1 Special Character (Ex. @ # $ %)</li>
                                </ul>'
                          v-bind:class="{
                            'is-invalid': $v.customer.password.$error
                          }"
                          ><template slot="append">
                            <span @click="seePassword()" class="icon-button"
                              ><i
                                v-bind:class="{
                                  'flaticon-view-1': typePassword == 'password',
                                  'flaticon-hidden': typePassword == 'text'
                                }"
                              ></i
                            ></span>
                          </template>
                        </base-input>
                        <small
                          class="invalid-feedback mt--1 mb-3"
                          v-if="$v.customer.password.$error"
                          >{{ validatePassword($v.customer.password) }}</small
                        >

                        <small
                          class="valid-feedback mt-0 mb-3"
                          v-if="$v.customer.password.strongPassword"
                          >Strong Password</small
                        >
                      </div>

                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mt-sm-0 mt-4"
                      >
                        <base-input
                          v-model.trim="$v.repeatPassword.$model"
                          label="Confirm Password"
                          placeholder="Confirm Password "
                          type="password"
                          id="confirm_password"
                          name="confirm_password"
                          maxlength="20"
                          tabindex="16"
                          :error="
                            !$v.repeatPassword.sameAsPassword ||
                            $v.repeatPassword.$error
                              ? `Passwords must be identical`
                              : ''
                          "
                        />
                      </div>

                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 form-group alinmov1"
                      >
                        <base-button
                          type="outline-secondary"
                          class="min-button"
                          @click="autogeneratePass()"
                        >
                          <i class="flaticon-bold-lock"></i>Generate Password
                        </base-button>

                        <base-button
                          type="outline-secondary"
                          class="min-button"
                          v-clipboard:copy="customer.password"
                          v-clipboard:success="onCopy"
                          v-clipboard:error="onErrorCopy"
                          v-if="customer.password"
                        >
                          <i class="flaticon-copy link ml-0"></i>Copy Password
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle">Address</h2>
                <div class="row" v-if="mode === 'view'">
                  <div
                    class="col-xl-12"
                    v-if="
                      customer.street ||
                        customer.city ||
                        customer.state ||
                        customer.zip_code ||
                        customer.country
                    "
                  >
                    <div class="row">
                      <div
                        class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                        v-if="customer.street"
                      >
                        <div class="data-block">
                          <span class="title-block"
                            >Street address, apartment, suite, etc.:</span
                          >
                          <span class="content-block">{{
                            customer.street
                          }}</span>
                        </div>
                      </div>

                      <div
                        class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                        v-if="customer.city"
                      >
                        <div class="data-block">
                          <span class="title-block">City</span>
                          <span class="content-block capitalize">{{
                            customer.city
                          }}</span>
                        </div>
                      </div>

                      <div
                        class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                        v-if="customer.state"
                      >
                        <div class="data-block">
                          <span class="title-block">State/Province/Region</span>
                          <span class="content-block">{{
                            customer.state
                          }}</span>
                        </div>
                      </div>

                      <div
                        class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                        v-if="customer.zip_code"
                      >
                        <div class="data-block">
                          <span class="title-block">Zip/Postal Code</span>
                          <span class="content-block">{{
                            customer.zip_code
                          }}</span>
                        </div>
                      </div>

                      <div
                        class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                        v-if="customer.country"
                      >
                        <div class="data-block">
                          <span class="title-block">Country</span>
                          <span class="content-block">{{
                            customer.country
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12" v-else>
                    <div class="data-block">
                      <span class="content-block">No Provided</span>
                    </div>
                  </div>
                </div>

                <div class="row mt-2" v-if="mode === 'edit'">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model="$v.customer.street.$model"
                      label="Street address, apartment, suite, etc."
                      placeholder="Street address, apartment, suite, etc"
                      id="customer_street"
                      name="customer_street"
                      maxlength="200"
                      tabindex="9"
                      format="capitalize"
                      :error="
                        !$v.customer.street.minLength ||
                        $v.customer.street.$error
                          ? `Enter from ${$v.customer.street.$params.minLength.min} to ${$v.customer.street.$params.maxLength.max} characters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model="$v.customer.city.$model"
                      label="City"
                      placeholder="City"
                      id="customer_city"
                      name="customer_city"
                      maxlength="45"
                      tabindex="10"
                      format="capitalize"
                      :error="
                        !$v.customer.city.minLength || $v.customer.city.$error
                          ? `Enter from ${$v.customer.city.$params.minLength.min} to ${$v.customer.city.$params.maxLength.max} letters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model="$v.customer.state.$model"
                      label="State/Province/Region"
                      placeholder="State/Province/Region"
                      id="customer_state"
                      name="customer_state"
                      maxlength="45"
                      tabindex="11"
                      format="capitalize"
                      :error="
                        !$v.customer.state.minLength || $v.customer.state.$error
                          ? `Enter from ${$v.customer.state.$params.minLength.min} to ${$v.customer.state.$params.maxLength.max} letters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model.trim="$v.customer.zip_code.$model"
                      label="Zip/Postal Code"
                      placeholder="Zip/Postal Code"
                      id="customer_zipcode"
                      name="customer_zipcode"
                      maxlength="45"
                      tabindex="12"
                      :error="
                        !$v.customer.zip_code.minLength ||
                        $v.customer.zip_code.$error
                          ? `Enter from ${$v.customer.zip_code.$params.minLength.min} to ${$v.customer.zip_code.$params.maxLength.max} characters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12">
                    <WSelect
                      v-bind:class="{
                        'invalid-feedback': $v.customer.country.$error
                      }"
                      v-model="$v.customer.country.$model"
                      label="Country"
                      placeholder="Enter a Country"
                      id="customer_country"
                      name="customer_country"
                      tabindex="13"
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="searchCountry"
                      :loading="loading"
                      clearable
                    >
                      <el-option
                        v-for="country in optionsCountries"
                        :value="country.name"
                        :label="country.name"
                        :key="country.name"
                      ></el-option>
                    </WSelect>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane id="paymentInfo" title="Payment Info" ref="paymentInfo">
              <div class="card">
                <div v-if="mode === 'view'">
                  <div class="row">
                    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-2 col-12">
                      <div class="data-block">
                        <span class="title-block">Markup</span>
                        <span class="content-block"
                          >{{ customer.mark_up }}%</span
                        >
                      </div>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12">
                      <div class="data-block">
                        <span class="title-block">Commercial Terms</span>
                        <span class="content-block">{{
                          getCommercialTerms(customer.type_charge)
                        }}</span>
                      </div>
                    </div>

                    <div
                      class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-12"
                      v-if="customer.type_charge === 'commission'"
                    >
                      <div class="data-block">
                        <span class="title-block">Commision</span>
                        <span class="content-block"
                          >{{ customer.commission }}%</span
                        >
                      </div>
                    </div>

                    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-12">
                      <div class="data-block">
                        <span class="title-block">Currency</span>
                        <span class="content-block">{{
                          getCurrencyName(currencyCode)
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-2 align-items-center" v-if="mode === 'edit'">
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <BaseNumberInput
                      v-model.number="$v.customer.mark_up.$model"
                      label="Markup"
                      placeholder="Markup"
                      id="customer_markup"
                      name="customer_markup"
                      maxlength="3"
                      tabindex="17"
                      class="input-append"
                      markrequired
                      @input="validateMarkup"
                      :error="
                        !$v.customer.mark_up.between
                          ? `Must be between ${$v.customer.mark_up.$params.between.min} to ${$v.customer.mark_up.$params.between.max}`
                          : ''
                      "
                    >
                      <template slot="append">%</template>
                    </BaseNumberInput>
                  </div>

                  <div
                    class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 switch-x-l form-group"
                  >
                    <label class="title-label">Commercial Terms</label>

                    <b-form-group v-slot="ariaDescribedby3" class="mb-2">
                      <b-form-radio-group
                        v-model="customer.type_charge"
                        @change="changeCommercialTerms"
                        :aria-describedby="ariaDescribedby3"
                        id="radio-commercial"
                        name="radio-comercial"
                        buttons
                        button-variant="outline-neutral"
                        size="md"
                      >
                        <b-form-radio
                          value="commission"
                          tabindex="18"
                          class="pc-1"
                          >Commission</b-form-radio
                        >
                        <b-form-radio value="net_price" class="pc-1"
                          >Net Price</b-form-radio
                        >
                      </b-form-radio-group>
                    </b-form-group>
                  </div>

                  <div
                    class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12"
                    v-if="customer.type_charge === 'commission'"
                  >
                    <BaseNumberInput
                      v-model.number="$v.customer.commission.$model"
                      @input="changeCommision"
                      label="Commision"
                      placeholder="Commision"
                      id="commission"
                      name="commission"
                      maxlength="3"
                      class="input-append"
                      tabindex="19"
                      markrequired
                      :error="
                        $v.customer.commission.$error
                          ? `Must be between ${$v.customer.commission.$params.between.min}% to ${$v.customer.commission.$params.between.max}%`
                          : ''
                      "
                    >
                      <template slot="append">%</template>
                    </BaseNumberInput>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <WSelect
                      :disabled="!hasCredit"
                      v-model="currencyCode"
                      label="Currency"
                      placeholder="Currency"
                      id="customer_currency"
                      name="customer_currency"
                      tabindex="20"
                    >
                      <el-option
                        v-for="(coin, index) in coins"
                        :value="coin.code"
                        :label="coin.label"
                        :key="index"
                      >
                        <span class="coin-left">{{ coin.label }}</span>
                        <span class="coin-right">{{ coin.symbol }}</span>
                      </el-option>
                    </WSelect>
                  </div>
                </div>
              </div>

              <div class="card">
                <div>
                  <div class="row mb-2">
                    <div class="col-6 align-self-center">
                      <h2 class="subtitle mb-0">Payment Methods</h2>
                    </div>
                    <div class="col-6 alinmov2 align-self-center">
                      <base-button
                        v-if="canUserCreate"
                        type="link"
                        class="min-button"
                        @click="createPaymentMethod()"
                      >
                        <i class="flaticon-plus"></i> Add new
                      </base-button>
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col-12 mb-4"
                      v-if="paymentMethodsOptions.length === 0"
                    >
                      <base-alert type="warning" class="mb-1 info-min">
                        <i class="flaticon-warning mr-1"></i> There are no
                        payment methods here
                      </base-alert>
                    </div>

                    <div class="col-12" v-else>
                      <div
                        v-for="(option, index) in paymentMethodsOptions"
                        :key="index"
                        class="card card-shadow pb-2"
                      >
                        <div class="row">
                          <div
                            class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12 align-self-center alinmov6"
                          >
                            <div
                              v-if="option.type === 'bank_account'"
                              class="mb-3"
                            >
                              <img
                                src="~rhomtrip_assets/src/img/icons/bank.png"
                                alt="bank"
                                class="icon-payment"
                              /><span class="d-block">
                                <strong>
                                  {{
                                    getTransferTypeMin(option.type_transfer)
                                  }}</strong
                                ></span
                              >
                            </div>

                            <div v-else>
                              <img
                                src="~rhomtrip_assets/src/img/icons/paypal.png"
                                alt="bank"
                                class="icon-payment mb-3"
                              />
                            </div>
                          </div>

                          <div
                            class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-12 align-self-center alinmov4"
                          >
                            <div class="data-block">
                              <h2 class="subtitle mb-0 d-md-inline d-sm-block">
                                {{ getPaymentMethodType(option.type) }}
                                <span
                                  class="badge-status badge-default ml-2"
                                  v-if="option.default"
                                  >Default</span
                                >
                              </h2>

                              <div v-if="option.type === 'bank_account'">
                                <span class="content-block"
                                  ><strong
                                    >Account Holder / Business Name:</strong
                                  >
                                  {{ option.name_account }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.name_account"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>

                                <span class="content-block"
                                  ><strong>Type Transfer:</strong>
                                  {{ getTransferType(option.type_transfer) }}
                                </span>

                                <span
                                  class="content-block"
                                  v-if="
                                    option.type_transfer === 'ach' ||
                                      option.type_transfer === 'wire'
                                  "
                                  ><strong>Account Type:</strong>
                                  {{ getAccountType(option.account_type) }}
                                </span>

                                <span
                                  class="content-block"
                                  v-if="
                                    option.type_transfer === 'ach' ||
                                      option.type_transfer === 'wire'
                                  "
                                  ><strong
                                    v-if="option.type_transfer === 'ach'"
                                  >
                                    ACH Routing Number:</strong
                                  >
                                  <strong
                                    v-else-if="option.type_transfer === 'wire'"
                                  >
                                    Fedwire Routing Number:</strong
                                  >
                                  {{ option.routing_number }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.routing_number"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span
                                  ></el-tooltip>
                                </span>

                                <span
                                  class="content-block"
                                  v-if="option.type_transfer === 'swift'"
                                  ><strong>SWIFT Code / BIC Code:</strong>
                                  {{ option.swift_code }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.swift_code"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>

                                <span
                                  class="content-block"
                                  v-if="option.type_transfer === 'transfer_gbp'"
                                  ><strong>UK Sort Code:</strong>
                                  {{ option.uk_sort_code }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.uk_sort_code"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>

                                <span class="content-block">
                                  <strong
                                    v-if="
                                      option.type_transfer === 'transfer_eur'
                                    "
                                    >IBAN:</strong
                                  >
                                  <strong
                                    v-else-if="option.type_transfer === 'swift'"
                                    >IBAN / Account Number:</strong
                                  >
                                  <strong v-else>Account Number:</strong>

                                  {{ option.account_number }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.iban"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>

                                <span class="content-block"
                                  ><strong>Recipient Address:</strong>
                                  {{
                                    getAddreess(
                                      option.address,
                                      option.city,
                                      option.post_code,
                                      option.country
                                    )
                                  }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="
                                        getAddreess(
                                          option.address,
                                          option.city,
                                          option.post_code,
                                          option.country
                                        )
                                      "
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>
                              </div>
                              <div v-else>
                                <span class="content-block"
                                  ><strong>Account:</strong> {{ option.email }}

                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.email"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>
                              </div>
                            </div>
                          </div>

                          <div
                            class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 align-self-center mb-3 alinmov6"
                          >
                            <el-tooltip content="Edit" placement="bottom">
                              <span
                                class="icon-action ml-2"
                                @click="editPaymentMethodByIndex(option, index)"
                              >
                                <i class="flaticon-pencil text-primary"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip
                              content="Mark by default"
                              placement="bottom"
                            >
                              <span
                                class="icon-action ml-2"
                                @click="makePaymentMethodAsDefault(index)"
                                v-if="!option.default"
                              >
                                <i class="flaticon-bold-button text-new"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip content="Delete" placement="bottom">
                              <span
                                class="icon-action ml-2"
                                @click="deletePaymentMethod(index)"
                              >
                                <i class="flaticon-delete text-danger"></i>
                              </span>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ManagePaymentMethod
                :show="showPaymentMethodModal"
                :paymentMethod="paymentMethod"
                :type="paymentMethodType"
                @addPaymentMethod="addPaymentMethod"
                @editPaymentMethod="editPaymentMethod"
                @closeModal="closePaymentMethodModal"
              />
            </tab-pane>

            <tab-pane
              id="Agents"
              title="Agents"
              ref="Agents"
              v-if="customer.type === 'travel_agency'"
            >
              <div class="card" v-if="partnerId && partnerType">
                <agent-list
                  :partnerId="partnerId"
                  :partnerType="partnerType"
                  :approve="customer.approve"
                ></agent-list>
              </div>
            </tab-pane>

            <tab-pane id="Metrics" title="Metrics" ref="Metrics">
              <Reservations
                v-if="partnerId && partnerType"
                :partner="{
                  id: partnerId,
                  type: partnerType
                }"
              />
            </tab-pane>

            <tab-pane
              id="Settings"
              title="Settings"
              ref="Settings"
              :disabledTab="!isConfigurable"
              msgDisabled="Option unavailable"
            >
              <div class="mt-2">
                <b-tabs content-class="mt-0">
                  <b-tab active>
                    <template #title> Referrals </template>

                    <div class="row">
                      <div class="col-12">
                        <div class="card pb-4">
                          <div class="row">
                            <div class="col-12">
                              <div class="data-block">
                                <span class="title-block"
                                  >Referral ID
                                  <el-popover
                                    placement="top"
                                    trigger="hover"
                                    width="300"
                                  >
                                    <p class="form-control-label mb-2">
                                      <strong
                                        >What is the agent's Referral
                                        ID?</strong
                                      >
                                    </p>
                                    <p class="text-justify f1 lh-f1 mb-0">
                                      It is a unique identifier that allows you
                                      to generate personalized links to share
                                      experiences with your clients or
                                      followers. When someone makes a
                                      reservation through one of these links,
                                      the booking is automatically attributed to
                                      you — even if the person booking is not
                                      registered on the platform.
                                    </p>

                                    <div
                                      class="badge badge-primary"
                                      slot="reference"
                                    >
                                      ?
                                    </div>
                                  </el-popover>
                                </span>

                                <span
                                  class="content-block"
                                  v-if="referenceCode"
                                >
                                  {{ referenceCode }}
                                </span>
                              </div>
                            </div>

                            <div class="col-xl-12" v-if="!referenceCode">
                              <base-alert type="warning" class="info-min">
                                <i class="flaticon-warning mr-1"></i> This
                                partner hasn't generated a referral ID yet. They
                                must generate it from their profile before they
                                can share referral links — or click the button
                                below to generate it now.
                              </base-alert>
                            </div>

                            <div
                              class="col-xl-5 col-lg-5 col-md-5 col-sm-7 col-12"
                              v-if="!referenceCode"
                            >
                              <base-button
                                type="outline-secondary"
                                class="min-button mb-3"
                                @click="generateReferenceCode()"
                              >
                                Generate Referral ID
                              </base-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>

                  <b-tab>
                    <template #title> Permissions </template>

                    <div class="card">
                      <div class="row">
                        <div class="col-12">
                          <div class="data-block">
                            <span class="title-block"
                              >Corporate image
                              <el-popover
                                placement="top"
                                trigger="hover"
                                width="300"
                                v-if="mode === 'edit'"
                              >
                                <p class="form-control-label mb-2">
                                  <strong>Corporate image</strong>
                                </p>
                                <p class="text-justify f1 lh-f1 mb-0">
                                  Activate permissions to personalize the app
                                  and notifications with your companySetting.
                                </p>

                                <div
                                  class="badge badge-primary"
                                  slot="reference"
                                >
                                  ?
                                </div>
                              </el-popover>
                            </span>
                          </div>
                        </div>

                        <div class="col-12" v-if="mode === 'edit'">
                          <div
                            class="row"
                            v-if="customer.type === 'travel_agency'"
                          >
                            <div
                              class="col-xl-6 col-lg-6 col-md-8 col-sm-9 col-8 align-self-center"
                            >
                              <span class="d-block mb-2"
                                >Customize the app and notifications with your
                                brand
                              </span>
                            </div>
                            <div
                              class="col-xl-6 col-lg-6 col-md-4 col-sm-3 col-4 align-self-center"
                            >
                              <base-switch
                                v-model="customer.settings.permissions.brand"
                                @input="changePermissions"
                                class="d-inline-flex"
                              ></base-switch>
                            </div>
                          </div>

                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-8 col-sm-9 col-8 align-self-center"
                            >
                              <span
                                class="d-block mb-2"
                                v-if="customer.type === 'travel_agency'"
                                >Allow Agents to customize Notifications/Emails
                              </span>
                              <span class="d-block mb-2" v-else=""
                                >Customize notifications with your personal data
                              </span>
                            </div>
                            <div
                              class="col-xl-6 col-lg-6 col-md-4 col-sm-3 col-4 align-self-center"
                            >
                              <base-switch
                                v-model="
                                  customer.settings.permissions.notifications
                                "
                                class="d-inline-flex"
                              ></base-switch>
                            </div>
                          </div>
                        </div>

                        <div class="col-12" v-if="mode === 'view'">
                          <div
                            class="row"
                            v-if="customer.type === 'travel_agency'"
                          >
                            <div
                              class="col-xl-6 col-lg-6 col-md-8 col-sm-9 col-8 align-self-center"
                            >
                              <span class="d-block mb-2"
                                >Customize the app and notifications with your
                                brand
                              </span>
                            </div>
                            <div
                              class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4 align-self-center text-center"
                            >
                              <div
                                class="badge-status badge-success mb-2"
                                v-if="customer.settings.permissions.brand"
                              >
                                <span>Active</span>
                              </div>

                              <div
                                class="badge-status badge-danger mb-2"
                                v-else
                              >
                                <span>Inactive</span>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-8 col-sm-9 col-8 align-self-center"
                            >
                              <span
                                class="d-block mb-2"
                                v-if="customer.type === 'travel_agency'"
                                >Allow Agents to customize Notifications/Emails
                              </span>
                              <span class="d-block mb-2" v-else=""
                                >Customize notifications with your personal data
                              </span>
                            </div>
                            <div
                              class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4 align-self-center text-center"
                            >
                              <div
                                class="badge-status badge-success mb-2"
                                v-if="
                                  customer.settings.permissions.notifications
                                "
                              >
                                <span>Active</span>
                              </div>

                              <div
                                class="badge-status badge-danger mb-2"
                                v-else
                              >
                                <span>Inactive</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>

                  <b-tab
                    v-if="
                      displayBrandTab(
                        customer.type,
                        customer.settings.permissions
                      )
                    "
                  >
                    <template #title> Brand </template>

                    <div v-if="mode === 'edit'">
                      <div class="row">
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
                        >
                          <div class="card">
                            <div class="row">
                              <div class="col-xl-12 pb-3">
                                <h2 class="subtitle">Logos</h2>
                                <div class="row">
                                  <div
                                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pb-3"
                                  >
                                    <div class="data-block">
                                      <span class="title-block"
                                        >Default
                                        <el-popover
                                          placement="top"
                                          trigger="hover"
                                          width="300"
                                          class="curp"
                                        >
                                          <ul class="ul-pop">
                                            <li>Logo in colors</li>
                                            <li>Transparent Background</li>
                                            <li>
                                              Minimum Dimensions Required: 150 x
                                              31 px
                                            </li>
                                            <li>
                                              Allowed Dimensions: 300 x 64 px
                                            </li>
                                            <li>Maximum Size: 2MB</li>
                                            <li>Allowed Formats: .PNG</li>
                                          </ul>
                                          <div
                                            class="badge badge-primary"
                                            slot="reference"
                                          >
                                            <span>?</span>
                                          </div>
                                        </el-popover>
                                      </span>
                                    </div>

                                    <div class="logo-load-default">
                                      <div
                                        class="image"
                                        @click="uploadLogos('default')"
                                      >
                                        <div class="img-logo-default">
                                          <LazyImage
                                            v-if="
                                              customer.settings.brand.logos
                                                .default
                                            "
                                            :src="
                                              customer.settings.brand.logos
                                                .default
                                            "
                                            imgClasses="logo-default"
                                          />

                                          <div
                                            v-else
                                            class="box-upload"
                                            :class="{
                                              invalid:
                                                $v.customer.settings.brand.logos
                                                  .default.$error
                                            }"
                                          >
                                            <i
                                              class="flaticon-arrow-up mr-1"
                                            ></i>
                                            <span>Upload your Logo</span>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="remove mb-3"
                                        v-if="
                                          customer.settings.brand.logos.default
                                        "
                                        @click="removeLogo('default')"
                                      >
                                        <span> Remove</span>
                                        <i class="flaticon-delete ml-1"></i>
                                      </div>

                                      <div
                                        class="invalid-feedback"
                                        v-if="
                                          $v.customer.settings.brand.logos
                                            .default.$error
                                        "
                                      >
                                        Upload your logo
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pb-3"
                                  >
                                    <div class="data-block">
                                      <span class="title-block"
                                        >Favicon
                                        <el-popover
                                          placement="top"
                                          trigger="hover"
                                          width="300"
                                          class="curp"
                                        >
                                          <ul class="ul-pop">
                                            <li>Logo Symbol in colors</li>
                                            <li>Transparent Background</li>
                                            <li>
                                              Minimum Dimensions: 60 x 60 px
                                            </li>
                                            <li>
                                              Allowed Dimensions: 300 x 300 px
                                            </li>
                                            <li>Maximum Size: 2MB</li>
                                            <li>Allowed Formats: PNG</li>
                                          </ul>
                                          <div
                                            class="badge badge-primary"
                                            slot="reference"
                                          >
                                            <span>?</span>
                                          </div>
                                        </el-popover>
                                      </span>
                                    </div>

                                    <div class="image-load-favicon">
                                      <div
                                        class="image"
                                        @click="uploadLogos('favicon')"
                                      >
                                        <div class="img-logo-favicon">
                                          <LazyImage
                                            v-if="
                                              customer.settings.brand.logos
                                                .favicon
                                            "
                                            :src="
                                              customer.settings.brand.logos
                                                .favicon
                                            "
                                            imgClasses="logo-favicon"
                                            @click="openBox(data.index)"
                                          />

                                          <div
                                            class="box-upload-favicon"
                                            v-else
                                          >
                                            <i class="flaticon-arrow-up"></i>
                                            <span>Upload your Favicon</span>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="remove mb-3"
                                        v-if="
                                          customer.settings.brand.logos.favicon
                                        "
                                        @click="removeLogo('favicon')"
                                      >
                                        <span> Remove</span>
                                        <i class="flaticon-delete ml-1"></i>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="card">
                            <div class="row">
                              <div class="col-xl-12 pb-3">
                                <h2 class="subtitle">
                                  Colors
                                  <el-popover
                                    placement="top"
                                    trigger="hover"
                                    width="300"
                                    class="curp"
                                  >
                                    <span>
                                      This represents your brand's colors and is
                                      usually part of your company's visual
                                      identity. This color will be used to
                                      highlight important and interactive
                                      elements in email communications, such
                                      as:</span
                                    >

                                    <ul class="ul-pop mt-2">
                                      <li>Primary action buttons</li>
                                      <li>Interactive links</li>
                                      <li>Visual indicators</li>
                                      <li>Hover or focus states</li>
                                      <li>Decorative or graphic elements</li>
                                      <li>Progress or ongoing actions"</li>
                                    </ul>
                                    <div
                                      class="badge badge-primary"
                                      slot="reference"
                                    >
                                      <span>?</span>
                                    </div>
                                  </el-popover>
                                </h2>
                                <div class="row">
                                  <div class="col-12 mb-2">
                                    <div
                                      class="form__field d-inline-flex align-items-center"
                                    >
                                      <div class="form__input">
                                        <v-swatches
                                          v-model="
                                            customer.settings.brand.colors
                                              .primary
                                          "
                                          :swatches="colors"
                                          close-on-select
                                          popover-x="left"
                                          popover-y="bottom"
                                          shapes="circles"
                                          swatch-size="32"
                                          row-length="8"
                                          show-fallback
                                          fallback-input-type="color"
                                          :trigger-style="{
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '50%'
                                          }"
                                          @input="getTextColorButtonBrand()"
                                        ></v-swatches>
                                      </div>
                                      <label
                                        class="title-label-np d-inline-flex ml-2 align-items-center"
                                      >
                                        Brand Color
                                      </label>
                                    </div>
                                  </div>

                                  <div class="col-12">
                                    <div class="row">
                                      <div
                                        class="ol-xl-8 col-lg-78 col-md-8 col-sm-7 col-8 align-self-center"
                                      >
                                        <span class="d-block mb-2"
                                          >Use brand color in the App theme
                                        </span>
                                      </div>
                                      <div
                                        class="col-xl-4 col-lg-4 col-md-4 col-sm-5 col-4 align-self-center"
                                      >
                                        <base-switch
                                          v-model="
                                            customer.settings.brand.colors
                                              .inTheme
                                          "
                                          @input="getBrandTheme()"
                                        ></base-switch>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                        >
                          <div class="card">
                            <div class="row">
                              <div class="col-xl-12 pb-3">
                                <h2 class="subtitle">
                                  App Theme
                                  <el-popover
                                    placement="top"
                                    trigger="hover"
                                    width="300"
                                    class="curp"
                                  >
                                    <span>
                                      Change the appearance of the app according
                                      to your preferences.</span
                                    >

                                    <div
                                      class="badge badge-primary"
                                      slot="reference"
                                    >
                                      <span>?</span>
                                    </div>
                                  </el-popover>
                                </h2>
                                <themeModel
                                  :color="customer.settings.brand.theme.color"
                                ></themeModel>
                              </div>

                              <div class="col-12 mb-2">
                                <div
                                  class="form__field d-inline-flex align-items-center"
                                >
                                  <div class="form__input">
                                    <v-swatches
                                      v-model="
                                        customer.settings.brand.theme.color
                                      "
                                      :swatches="colors"
                                      close-on-select
                                      popover-x="left"
                                      popover-y="bottom"
                                      shapes="circles"
                                      swatch-size="32"
                                      row-length="8"
                                      show-fallback
                                      fallback-input-type="color"
                                      :trigger-style="{
                                        width: '32px',
                                        height: '32px',
                                        borderRadius: '50%'
                                      }"
                                      :disabled="
                                        customer.settings.brand.colors.inTheme
                                      "
                                    ></v-swatches>
                                  </div>
                                  <label
                                    class="title-label-np d-inline-flex ml-2 align-items-center"
                                  >
                                    Theme Color
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="mode === 'view'">
                      <div class="row">
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
                        >
                          <div class="card">
                            <div class="row">
                              <div class="col-xl-12">
                                <h2 class="subtitle">Logos</h2>
                                <div class="row">
                                  <div
                                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pb-3"
                                  >
                                    <div class="data-block">
                                      <span class="title-block">Default </span>
                                    </div>

                                    <div class="logo-load-default preview">
                                      <div class="image">
                                        <div class="img-logo-default">
                                          <LazyImage
                                            v-if="
                                              customer.settings.brand.logos
                                                .default
                                            "
                                            :src="
                                              customer.settings.brand.logos
                                                .default
                                            "
                                            imgClasses="logo-default"
                                          />

                                          <div
                                            v-else
                                            v-bind:style="{
                                              backgroundImage:
                                                'url(' + noPreviewView + ')'
                                            }"
                                            class="logo-default preview"
                                          ></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pb-3"
                                  >
                                    <div class="data-block">
                                      <span class="title-block">Favicon </span>
                                    </div>

                                    <div class="image-load-favicon preview">
                                      <div class="image">
                                        <div class="img-logo-favicon">
                                          <LazyImage
                                            v-if="
                                              customer.settings.brand.logos
                                                .favicon
                                            "
                                            :src="
                                              customer.settings.brand.logos
                                                .favicon
                                            "
                                            imgClasses="logo-favicon"
                                          />
                                          <div
                                            v-else
                                            v-bind:style="{
                                              backgroundImage:
                                                'url(' + noPreviewView + ')'
                                            }"
                                            class="logo-favicon preview"
                                          ></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="card">
                            <div class="row">
                              <div class="col-xl-12 pb-3">
                                <h2 class="subtitle">Colors</h2>
                                <div class="row">
                                  <div class="col-12 mb-2">
                                    <div class="d-flex align-items-center">
                                      <div
                                        class="color-circle d-inline-flex"
                                        v-bind:style="{
                                          'background-color':
                                            customer.settings.brand.colors
                                              .primary
                                        }"
                                      ></div>
                                      <label
                                        class="title-label-np d-inline-flex ml-2 mb-0"
                                      >
                                        Brand Color
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                        >
                          <div class="card">
                            <div class="row">
                              <div class="col-xl-12 pb-3">
                                <h2 class="subtitle">App Theme</h2>
                                <themeModel
                                  :color="customer.settings.brand.theme.color"
                                ></themeModel>
                              </div>

                              <div class="col-12 mb-2">
                                <div class="d-flex align-items-center">
                                  <div
                                    class="color-circle d-inline-flex"
                                    v-bind:style="{
                                      'background-color':
                                        customer.settings.brand.theme.color
                                    }"
                                  ></div>
                                  <label
                                    class="title-label-np d-inline-flex ml-2 mb-0"
                                  >
                                    Theme Color
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab
                    v-if="
                      displayNotificationTab(
                        customer.type,
                        customer.settings.permissions
                      )
                    "
                  >
                    <template #title> Notifications </template>

                    <div v-if="mode === 'edit'">
                      <div class="row">
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
                        >
                          <div class="card">
                            <div class="row">
                              <div class="col-xl-12">
                                <h2 class="subtitle mb-4">
                                  Info Notifications / Emails
                                  <el-popover
                                    placement="top"
                                    trigger="hover"
                                    width="300"
                                    class="curp"
                                  >
                                    <span>
                                      This information is used in the header,
                                      body and footer of emails notifications
                                      and in the Voucher.
                                      <br /><br />
                                      If you leave it blank, the Rhomtrip
                                      information will be displayed by default.
                                    </span>
                                    <div
                                      class="badge badge-primary"
                                      slot="reference"
                                    >
                                      <span>?</span>
                                    </div>
                                  </el-popover>
                                </h2>
                                <div class="row">
                                  <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                  >
                                    <base-input
                                      v-model="
                                        customer.settings.entityDetails.pages
                                          .web
                                      "
                                      id="website"
                                      name="website"
                                      label="Web Site"
                                      placeholder="Web site"
                                      :tooltip="true"
                                      titleTooltip="Web Site"
                                      contentTooltip="Enter full URL, including http or https.
                                                    <br />Ex:
                                                    <strong>https://www.rhomtrip.com/</strong>"
                                    />
                                  </div>

                                  <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                  >
                                    <base-input
                                      v-model="
                                        $v.customer.settings.entityDetails.pages
                                          .contact.$model
                                      "
                                      :error="
                                        $v.customer.settings.entityDetails.pages
                                          .contact.$error
                                          ? `Enter Contact Page / Whatsapp URL`
                                          : ''
                                      "
                                      id="contact_page"
                                      name="contact_page"
                                      label="Contact Page / Whatsapp URL"
                                      placeholder="Contact Page"
                                      :tooltip="true"
                                      titleTooltip="Contact Page Url"
                                      contentTooltip="Enter full URL, including http or https.
                                    <br />Ex:
                                    <strong>https://www.rhomtrip.com/contact</strong>"
                                    />
                                  </div>

                                  <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                  >
                                    <base-input
                                      v-model="
                                        $v.customer.settings.entityDetails
                                          .contact.phoneNumber.$model
                                      "
                                      :error="
                                        $v.customer.settings.entityDetails
                                          .contact.phoneNumber.$error
                                          ? `Enter Contact Phone`
                                          : ''
                                      "
                                      id="ContactPhone"
                                      name="ContactPhone"
                                      label="Contact Phone"
                                      placeholder="Contact Phone"
                                      :tooltip="true"
                                      titleTooltip="Contact Phone"
                                      contentTooltip="Enter the contact phone number, including code zone
                                          <br />Ex:
                                          <strong>+37 28801604</strong>"
                                    />
                                  </div>

                                  <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                  >
                                    <base-input
                                      v-model="
                                        $v.customer.settings.entityDetails
                                          .contact.email.$model
                                      "
                                      :error="
                                        $v.customer.settings.entityDetails
                                          .contact.email.$error
                                          ? `Enter Contact Email`
                                          : ''
                                      "
                                      id="Contact Email"
                                      name="ContactEmail"
                                      label="Contact Email"
                                      placeholder="Contact Email"
                                      :tooltip="true"
                                      titleTooltip="Contact Email"
                                      contentTooltip=" Enter the contact email address
                                                      <br />Ex:
                                                      <strong>booking@rhomtrip.com</strong>"
                                    />
                                  </div>

                                  <div class="col-xl-12 col-12 form-group">
                                    <label
                                      for="colorCorporate"
                                      class="title-label mb-2"
                                    >
                                      Important Note / Attention
                                      <el-popover
                                        placement="top"
                                        trigger="hover"
                                        width="300"
                                      >
                                        <p class="form-control-label mb-2">
                                          <strong
                                            >Important Note / Attention</strong
                                          >
                                        </p>
                                        <p class="text-left f1 lh-f1 mb-0">
                                          Enter important and relevant
                                          information that you must include at
                                          the end as the last paragraph of the
                                          emails
                                          <br />Ex:
                                          <br />
                                          <strong>
                                            For all services, before a No Show
                                            is considered and Driver released,
                                            contact passenger or RhomTrip by
                                            phone.
                                          </strong>
                                        </p>

                                        <div
                                          class="badge badge-primary"
                                          slot="reference"
                                        >
                                          ?
                                        </div>
                                      </el-popover>
                                    </label>

                                    <el-input
                                      v-model="
                                        $v.customer.settings.entityDetails
                                          .importantNote.$model
                                      "
                                      id="important_note"
                                      name="important_note"
                                      maxlength="5000"
                                      type="textarea"
                                      :autosize="{ minRows: 2, maxRows: 5 }"
                                      show-word-limit
                                    >
                                    </el-input>
                                    <div
                                      class="invalid-feedback mt-0"
                                      v-if="
                                        !$v.customer.settings.entityDetails
                                          .importantNote.minLength ||
                                          $v.customer.settings.entityDetails
                                            .importantNote.$error
                                      "
                                    >
                                      Minimum 100 characteres
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                  >
                                    <base-input
                                      v-model="
                                        customer.settings.entityDetails.pages
                                          .termsConditions
                                      "
                                      id="website_terms_page"
                                      name="website_terms_page"
                                      placeholder="Web site"
                                      label="Terms & Conditions URL Page"
                                      :tooltip="true"
                                      titleTooltip="Terms & Conditions URL Page"
                                      contentTooltip="Enter full URL, including http or https.
                                                  <br />Ex:
                                                  <strong>https://www.rhomtrip.com/terms-conditions</strong>"
                                    />
                                  </div>

                                  <div class="col-12">
                                    <hr />

                                    <div class="data-block">
                                      <span class="title-block"
                                        >Social Media
                                        <el-popover
                                          placement="top"
                                          trigger="hover"
                                          width="300"
                                        >
                                          <p class="form-control-label mb-2">
                                            <strong>Social Media</strong>
                                          </p>
                                          <p class="text-left f1 lh-f1 mb-0">
                                            Enter full URL, including http or
                                            https.
                                            <br />Ex:
                                            <strong>
                                              https://www.facebook.com/rhomtrip
                                            </strong>
                                          </p>

                                          <div
                                            class="badge badge-primary"
                                            slot="reference"
                                          >
                                            ?
                                          </div>
                                        </el-popover>
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12"
                                  >
                                    <base-input
                                      v-model="
                                        $v.customer.settings.socialmedia
                                          .facebook.$model
                                      "
                                      :error="
                                        $v.customer.settings.socialmedia
                                          .facebook.$error
                                          ? `Enter valid Facebook URL.`
                                          : ''
                                      "
                                      id="facebook"
                                      name="facebook"
                                      label="Facebook"
                                      placeholder="Facebook"
                                    />
                                  </div>

                                  <div
                                    class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12"
                                  >
                                    <base-input
                                      v-model="
                                        $v.customer.settings.socialmedia.twitter
                                          .$model
                                      "
                                      :error="
                                        $v.customer.settings.socialmedia.twitter
                                          .$error
                                          ? `Enter valid Twitter URL.`
                                          : ''
                                      "
                                      id="Twitter"
                                      name="Twitter"
                                      label="Twitter / X"
                                      placeholder="Twitter"
                                    />
                                  </div>

                                  <div
                                    class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12"
                                  >
                                    <base-input
                                      v-model="
                                        $v.customer.settings.socialmedia
                                          .instagram.$model
                                      "
                                      :error="
                                        $v.customer.settings.socialmedia
                                          .instagram.$error
                                          ? `Enter valid Instagram URL.`
                                          : ''
                                      "
                                      id="Instagram"
                                      name="Instagram"
                                      label="Instagram"
                                      placeholder="Instagram"
                                    />
                                  </div>

                                  <div
                                    class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12"
                                  >
                                    <base-input
                                      v-model="
                                        $v.customer.settings.socialmedia
                                          .linkedin.$model
                                      "
                                      :error="
                                        $v.customer.settings.socialmedia
                                          .linkedin.$error
                                          ? `Enter valid Linkedin URL`
                                          : ''
                                      "
                                      id="Linkedin"
                                      name="Linkedin"
                                      label="Linkedin"
                                      placeholder="Linkedin"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                        >
                          <div class="card">
                            <div class="row">
                              <div class="col-12 align-self-center">
                                <h2 class="subtitle">
                                  Model template
                                  <el-popover
                                    placement="top"
                                    trigger="hover"
                                    width="300"
                                    class="curp"
                                  >
                                    <span
                                      >This is a sample of what the email
                                      template sent to customers will look
                                      like.</span
                                    >
                                    <div
                                      class="badge badge-primary"
                                      slot="reference"
                                    >
                                      <span>?</span>
                                    </div>
                                  </el-popover>
                                </h2>
                              </div>

                              <div class="col-12 mb-3 text-center">
                                <templateModel
                                  :color="
                                    customer.settings.brand.colors.primary
                                  "
                                ></templateModel>

                                <base-button
                                  class="btn min-button lh-100 mt-3 no-mobile"
                                  type="outline-secondary"
                                  @click="modalpreview = true"
                                >
                                  See Preview
                                </base-button>
                              </div>
                            </div>
                          </div>

                          <div class="card">
                            <div class="row">
                              <div class="col-12 align-self-center">
                                <h2 class="subtitle">
                                  Pickup Sign
                                  <el-popover
                                    placement="top"
                                    trigger="hover"
                                    width="300"
                                    class="curp"
                                  >
                                    <span
                                      >For any pickup, the driver will greet
                                      passenger(s) upon arrival with a sign with
                                      their name</span
                                    >
                                    <div
                                      class="badge badge-primary"
                                      slot="reference"
                                    >
                                      <span>?</span>
                                    </div>
                                  </el-popover>
                                </h2>
                              </div>
                              <div
                                class="col-xl-8 col-lg-8 col-md-7 col-sm-7 col-8 align-self-center"
                              >
                                <span class="d-block mb-2"
                                  >Branded name-Pickup Sign
                                </span>
                              </div>
                              <div
                                class="col-xl-4 col-lg-4 col-md-5 col-sm-4 col-4 align-self-center"
                              >
                                <base-switch
                                  v-model="customer.settings.brand.pickupSign"
                                  :disabled="
                                    customer.settings.brand.logos.default === ''
                                  "
                                ></base-switch>
                              </div>
                            </div>

                            <div class="row justify-content-center mb-3">
                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-5 col-8"
                              >
                                <div class="box-pickup">
                                  <img
                                    v-if="
                                      customer.settings.brand.logos.default &&
                                        customer.settings.brand.pickupSign
                                    "
                                    :src="customer.settings.brand.logos.default"
                                    alt="logo"
                                  />
                                  <img
                                    v-else
                                    :src="
                                      require('rhomtrip_assets/src/img/brand/logo-rhomtrip-1p300.png')
                                    "
                                    alt="logo"
                                  />
                                  <span>Mrs. Helen White</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="mode === 'view'">
                      <div class="row">
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
                        >
                          <div class="card">
                            <div class="row">
                              <div class="col-xl-12">
                                <h2 class="subtitle mb-4">
                                  Info Notifications / Emails
                                </h2>
                                <div class="row">
                                  <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                    v-if="
                                      customer.settings.entityDetails.company
                                        .name
                                    "
                                  >
                                    <div class="data-block">
                                      <span class="title-block">
                                        Company Name / Personal Name
                                      </span>
                                      <span class="content-block">
                                        {{
                                          customer.settings.entityDetails
                                            .company.name
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                  <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                    v-if="
                                      customer.settings.entityDetails.pages.web
                                    "
                                  >
                                    <div class="data-block">
                                      <span class="title-block">
                                        Web Site
                                      </span>
                                      <span class="content-block">
                                        <a
                                          target="_blank"
                                          :href="
                                            customer.settings.entityDetails
                                              .pages.web
                                          "
                                        >
                                          {{
                                            customer.settings.entityDetails
                                              .pages.web
                                          }}
                                        </a>
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                    v-if="
                                      customer.settings.entityDetails.pages
                                        .contact
                                    "
                                  >
                                    <div class="data-block">
                                      <span class="title-block">
                                        Contact Page / Whatsapp URL
                                      </span>
                                      <span class="content-block">
                                        <a
                                          target="_blank"
                                          :href="
                                            customer.settings.entityDetails
                                              .pages.contact
                                          "
                                        >
                                          {{
                                            customer.settings.entityDetails
                                              .pages.contact
                                          }}
                                        </a>
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                    v-if="
                                      customer.settings.entityDetails.contact
                                        .phoneNumber
                                    "
                                  >
                                    <div class="data-block">
                                      <span class="title-block">
                                        Contact Phone
                                      </span>
                                      <span class="content-block">
                                        <a
                                          target="_blank"
                                          :href="
                                            `tel:${customer.settings.entityDetails.contact.phoneNumber}`
                                          "
                                        >
                                          {{
                                            customer.settings.entityDetails
                                              .contact.phoneNumber
                                          }}
                                        </a>
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                    v-if="
                                      customer.settings.entityDetails.contact
                                        .email
                                    "
                                  >
                                    <div class="data-block">
                                      <span class="title-block">
                                        Contact Email
                                      </span>
                                      <span class="content-block">
                                        <a
                                          target="_blank"
                                          :href="
                                            `mailto:${customer.settings.entityDetails.contact.email}`
                                          "
                                        >
                                          {{
                                            customer.settings.entityDetails
                                              .contact.email
                                          }}
                                        </a>
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                    v-if="
                                      customer.settings.entityDetails.pages
                                        .termsConditions
                                    "
                                  >
                                    <div class="data-block">
                                      <span class="title-block">
                                        Terms & Conditions URL Page
                                      </span>
                                      <span class="content-block">
                                        <a
                                          target="_blank"
                                          :href="
                                            customer.settings.entityDetails
                                              .pages.termsConditions
                                          "
                                        >
                                          {{
                                            customer.settings.entityDetails
                                              .pages.termsConditions
                                          }}
                                        </a>
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-12 col-12"
                                    v-if="
                                      customer.settings.entityDetails
                                        .importantNote
                                    "
                                  >
                                    <div class="data-block">
                                      <span class="title-block">
                                        Important Note / Attention
                                      </span>
                                      <span class="content-block">
                                        {{
                                          customer.settings.entityDetails
                                            .importantNote
                                        }}
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="col-12"
                                    v-if="
                                      customer.settings.socialmedia.facebook ||
                                        customer.settings.socialmedia.twitter ||
                                        customer.settings.socialmedia
                                          .instagram ||
                                        customer.settings.socialmedia.linkedin
                                    "
                                  >
                                    <hr />

                                    <div class="data-block">
                                      <span class="title-block"
                                        >Social Media
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                                    v-if="
                                      customer.settings.socialmedia.facebook
                                    "
                                  >
                                    <div class="data-block">
                                      <span class="title-block">
                                        Facebook
                                      </span>
                                      <span class="content-block">
                                        <a
                                          target="_blank"
                                          :href="
                                            customer.settings.socialmedia
                                              .facebook
                                          "
                                        >
                                          {{
                                            customer.settings.socialmedia
                                              .facebook
                                          }}</a
                                        >
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                                    v-if="customer.settings.socialmedia.twitter"
                                  >
                                    <div class="data-block">
                                      <span class="title-block"> Twitter </span>
                                      <span class="content-block">
                                        <a
                                          target="_blank"
                                          :href="
                                            customer.settings.socialmedia
                                              .twitter
                                          "
                                        >
                                          {{
                                            customer.settings.socialmedia
                                              .twitter
                                          }}</a
                                        >
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                                    v-if="
                                      customer.settings.socialmedia.instagram
                                    "
                                  >
                                    <div class="data-block">
                                      <span class="title-block">
                                        Instagram
                                      </span>
                                      <span class="content-block">
                                        <a
                                          target="_blank"
                                          :href="
                                            customer.settings.socialmedia
                                              .instagram
                                          "
                                        >
                                          {{
                                            customer.settings.socialmedia
                                              .instagram
                                          }}</a
                                        >
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                                    v-if="
                                      customer.settings.socialmedia.linkedin
                                    "
                                  >
                                    <div class="data-block">
                                      <span class="title-block">
                                        Linkedin
                                      </span>
                                      <span class="content-block">
                                        <a
                                          target="_blank"
                                          :href="
                                            customer.settings.socialmedia
                                              .linkedin
                                          "
                                        >
                                          {{
                                            customer.settings.socialmedia
                                              .linkedin
                                          }}</a
                                        >
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                        >
                          <div class="card">
                            <div class="row">
                              <div class="col-12 align-self-center">
                                <h2 class="subtitle">Model template</h2>
                              </div>

                              <div class="col-12 mb-3 text-center">
                                <templateModel
                                  :color="
                                    customer.settings.brand.colors.primary
                                  "
                                ></templateModel>

                                <base-button
                                  class="btn min-button lh-100 mt-3 no-mobile"
                                  type="outline-secondary"
                                  @click="modalpreview = true"
                                >
                                  See Preview
                                </base-button>
                              </div>
                            </div>
                          </div>

                          <div class="card">
                            <div class="row">
                              <div class="col-12 align-self-center">
                                <h2 class="subtitle">Pickup Sign</h2>
                              </div>
                            </div>

                            <div class="row justify-content-center mb-3">
                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-5 col-8"
                              >
                                <div class="box-pickup">
                                  <img
                                    v-if="
                                      customer.settings.brand.logos.default &&
                                        customer.settings.brand.pickupSign
                                    "
                                    :src="customer.settings.brand.logos.default"
                                    alt="logo"
                                  />
                                  <img
                                    v-else
                                    :src="
                                      require('rhomtrip_assets/src/img/brand/logo-rhomtrip-1p300.png')
                                    "
                                    alt="logo"
                                  />
                                  <span>Mrs. Helen White</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>
    <PartnerChange
      :show="showChangeModal"
      :partnerId="partnerId"
      :agencies="agencies"
      @closeChangeModal="closeChangeModal"
      @partnerChanged="onPartnerChange"
    />

    <modal :show.sync="modalpreview" size="lg" bodyClasses="pt-0 pb-0">
      <template slot="header">
        <h2 class="subtitle mb-4">Example Template New Reservation</h2>
      </template>
      <PreviewBrandTemplate :settings="customer.settings" />
      <template slot="footer">
        <base-button type="secondary" size="sm" @click="modalpreview = false"
          >Close</base-button
        >
      </template>
    </modal>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs,
  numeric,
  minValue,
  requiredIf,
  decimal,
  between,
  helpers,
  url
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import {
  PartnersAPI,
  CustomersAPI,
  AuthAPI,
  AgentsAPI
} from "../../../core/api";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import moment from "moment-timezone";
import lodash from "lodash";
import StatsCard from "rhomtrip_assets/src/components/Cards/StatsCard";
import agentlist from "../components/AgentsList.vue";
import ManagePaymentMethod from "../components/ManagePaymentMethod.vue";
import Reservations from "../components/Reservations.vue";
import generator from "generate-password";
import PartnerChange from "../components/PartnerChange.vue";
import Pusher from "pusher-js";
import VSwatches from "vue-swatches";
import themeModel from "@/components/model-theme.vue";
import templateModel from "@/components/template-email-svg.vue";
import PreviewBrandTemplate from "@/components/PreviewBrandTemplate.vue";
import slugify from "slugify";
import ShortUniqueId from "short-unique-id";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";
import { FileService } from "../../../core/services";
import { BYTESCALE_API_PUBLIC_KEY } from "../../../core/config/env";
const { randomUUID } = new ShortUniqueId({ length: 10 });
const uploader = Uploader({
  apiKey: BYTESCALE_API_PUBLIC_KEY
});
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "EditCustomers",
  data() {
    return {
      customer: {
        type: "travel_access",
        first_name: "",
        last_name: "",
        full_name: "",
        email: "",
        password: "",
        phone: "",
        contact_info: "",
        gender: "other",
        country: "",
        city: "",
        state: "",
        zip_code: "",
        street: "",
        notes: "",
        company_name: "",
        type_markup: "markup",
        type_charge: "net_price",
        vat_number: "",
        mark_up: 0,
        session: false,
        status: false,
        relationship: {
          owner: "",
          type: ""
        },
        other_contact_platform: "",
        currency: {
          code: "USD",
          symbol: "$",
          label: "US Dollar"
        },
        credit: {
          status: false,
          limit: 0,
          available: 0
        },
        source: "rhomtrip",
        url_picture: "",
        iata_code: "",
        legal_name: "",
        association: null,
        approve: true,
        managed_account: true,
        commission: 10,
        referenceCode: "",
        settings: {
          brand: {
            logos: {
              default: "",
              favicon: ""
            },
            colors: {
              primary: "#4b56a6",
              buttonText: "#FFFFFF",
              inTheme: false
            },
            theme: {
              color: "#4b56a6",
              buttonText: "#FFFFFF"
            },
            pickupSign: false
          },
          socialmedia: {
            facebook: "",
            twitter: "",
            instagram: "",
            linkedin: ""
          },
          permissions: {
            brand: false,
            notifications: false
          },
          entityDetails: {
            company: {
              relationship: true,
              name: "",
              email: "",
              vatnumber: ""
            },
            contact: {
              phoneNumber: "",
              email: ""
            },
            pages: {
              web: "",
              contact: "",
              faq: "",
              termsConditions: ""
            },
            importantNote: ""
          }
        }
      },
      loading: false,
      optionsCountries: [],
      saved: false,
      contact_platform: [
        { value: "Whatsapp", label: "Whatsapp" },
        { value: "Skype", label: "Skype" }
      ],
      typePassword: "password",
      coins: [
        { code: "USD", symbol: "$", label: "US Dollar" },
        { code: "EUR", symbol: "€", label: "Euro" },
        { code: "GBP", symbol: "£", label: "British Pound" },
        { code: "CHF", symbol: "₣", label: "Swiss Franc" },
        { code: "DKK", symbol: "kr", label: "Denmark Krone" },
        { code: "SEK", symbol: "kr", label: "Swedish Krona" },
        { code: "NOK", symbol: "kr", label: "Norwegian Krone" },
        { code: "ISK", symbol: "kr", label: "Icelandic Króna" },
        { code: "AED", symbol: "د.إ", label: "United Arab Emirates Dirham" }
      ],
      currencyCode: "USD",
      creditAvailable: 0,
      creditLimit: 0,
      oldCreditLimit: 0,
      pendingPayment: 0,
      customerCopy: {},
      created: "",
      source: "rhombuss",
      customerStatus: false,
      picture: "",
      edit: true,
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      tabActive: "Overview",
      partnerId: null,
      partnerType: "",
      phoneFormat: "",
      repeatPassword: "",
      mode: "view",
      paymentMethods: [],
      paymentMethodsOptions: [],
      showPaymentMethodModal: false,
      paymentMethod: null,
      paymentMethodIndex: 0,
      paymentMethodType: "create",
      agencies: [],
      association: null,
      showChangeModal: false,
      lastCommission: 0,
      loadingData: true,
      pusher: null,
      hasCredit: false,
      noPreview: require("rhomtrip_assets/src/img/placeholder-logo.jpg"),
      noPreviewFavicon: require("rhomtrip_assets/src/img/placeholder-favicon.jpg"),
      noPreviewView: require("rhomtrip_assets/src/img/no-preview.png"),
      colors: [
        "#000000",
        "#666666",
        "#999999",
        "#980000",
        "#cc0000",
        "#f60000",
        "#E84B3C",
        "#e69138",
        "#F39C19",
        "#FFBB00",
        "#133217",
        "#028900",
        "#6aa84f",
        "#45818e",
        "#3c78d8",
        "#3F2AD4",
        "#25197F",
        "#0A0055",
        "#674ea7",
        "#8E43AD",
        "#A463BF",
        "#a64d79",
        "#CC0254",
        "#FF00A7"
      ],
      modalpreview: false,
      isConfigurable: true,
      referenceCode: ""
    };
  },
  components: {
    flatPicker,
    VueTelInput,
    WSelect,
    StatsCard,
    "agent-list": agentlist,
    ManagePaymentMethod: ManagePaymentMethod,
    Reservations: Reservations,
    PartnerChange,
    VSwatches,
    themeModel,
    templateModel,
    PreviewBrandTemplate: PreviewBrandTemplate
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Partners",
        to: "/partners"
      },
      {
        text: "Partner Profile",
        active: true
      }
    ];
    Pusher.logToConsole = process.env.VUE_APP_ENV === "development";
    this.pusher = new Pusher(process.env.VUE_APP_PUSHER_API_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER
    });
    this.setItemsBread(bread);
    await this.initData(this.$route.params.id);
    this.controllingChanges("customers");
  },
  watch: {
    currencyCode: {
      handler: function(current, old) {
        let currency = this.coins.find(element => element.code === current);
        this.customer.currency = {
          code: currency ? currency.code : "",
          symbol: currency ? currency.symbol : "",
          label: currency ? currency.label : ""
        };
      },
      deep: true
    },
    password: {
      handler: function(current, old) {
        if (current) {
          this.customer.session = true;
          this.customer.status = true;
        } else {
          this.customer.session = false;
          this.customer.status = false;
        }
      },
      deep: true
    },
    "$route.params.id": {
      handler: async function(current, old) {
        this.paymentMethods = [];
        this.paymentMethodsOptions = this.paymentMethods;
        this.showPaymentMethodModal = false;
        this.paymentMethod = null;
        this.paymentMethodIndex = 0;
        this.paymentMethodType = "create";
        this.association = null;
        this.mode = "view";
        this.tabActive = "Overview";
        this.loadingData = true;
        this.hasCredit = false;
        this.agencies = await this.getPartnersOptions();
        await this.initData(current);
      },
      deep: true
    }
  },

  methods: {
    async initData(partnerId) {
      this.partnerId = partnerId;
      this.agencies = await this.getPartnersOptions();
      await this.getCustomer(this.partnerId);
    },
    async getCustomer(partnerId, loader = true) {
      try {
        this.setLoad(loader);
        let { data } = await PartnersAPI.getPartnerById(
          partnerId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let customer = data.data;
          this.association = customer.association;
          this.isConfigurable = this.isConfigurationAllowed(
            customer.type,
            this.association
              ? this.association.settings.permissions.notifications
              : false
          );
          this.partnerType = customer.type;
          this.customer.first_name = customer.first_name;
          this.customer.last_name = customer.last_name;
          this.customer.company_name = customer.company_name;
          this.customer.vat_number = customer.vat_number;
          this.customer.email = customer.email;
          this.$v.customer.email.$model = customer.email;
          this.lastEmail = customer.email;
          this.customer.type_markup = customer.type_markup;
          this.customer.phone = customer.phone;
          this.phoneFormat = `${this.customer.phone}`;
          this.customer.gender = customer.gender;
          this.customer.country = customer.country;
          this.customer.city = customer.city;
          this.customer.state = customer.state;
          this.customer.zip_code = customer.zip_code;
          this.customer.street = customer.street;
          this.customer.notes = customer.notes;
          this.customer.mark_up = customer.mark_up;
          this.customer.type_charge = customer.type_charge;
          this.customer.managed_account = customer.managed_account;
          this.customer.commission = customer.commission;
          this.lastCommission = this.customer.commission;
          this.customer.type = customer.type;
          this.customer.relationship = lodash.cloneDeep(customer.relationship);
          this.customer.other_contact_platform =
            customer.other_contact_platform;
          this.customer.contact_info = customer.contact_info;

          this.customer.credit.status = customer.credit.status;

          this.customer.credit.limit = customer.credit.limit;
          this.creditLimit = this.customer.credit.limit;

          this.oldCreditLimit = this.customer.credit.limit;

          this.customer.credit.available = customer.credit.available;
          this.creditAvailable = this.customer.credit.available;

          this.customer.referenceCode = customer.referenceCode;
          this.referenceCode = customer.referenceCode;

          this.pendingPayment = parseFloat(
            parseFloat(this.creditLimit - this.creditAvailable).toFixed(2)
          );
          this.paymentMethods = customer.payment_methods
            ? customer.payment_methods
            : [];
          this.paymentMethodsOptions = this.moveElementToFirst(
            this.paymentMethods
          );
          this.currencyCode = customer.currency.code;
          this.customer.currency.code = customer.currency.code;
          this.customer.currency.symbol = customer.currency.symbol;
          this.customer.currency.label = customer.currency.label;
          this.customer.session = customer.session;
          this.customer.status = customer.status;
          this.customer.source = customer.source;
          this.customer.url_picture = customer.url_picture;
          this.customer.legal_name = customer.legal_name;
          this.customer.iata_code = customer.iata_code;
          this.customer.approve = customer.approve;
          this.customer.association = customer.association
            ? customer.association._id
            : null;
          this.customer.settings = customer.settings;

          this.hasCredit = customer.association
            ? customer.association.credit.status
            : customer.credit.status;
          this.source =
            ["rhomtrip", "rhombuss"].indexOf(customer.source) > -1
              ? "RhomTrip"
              : "Web";
          this.customerStatus = true;
          this.created = moment(customer.created_at).format(
            "DD MMM. YYYY - hh:mm A"
          );
          this.customerCopy = lodash.cloneDeep(this.customer);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "There was an error loading the Customer, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error loading the Customer, please try again"
        );
      } finally {
        this.loadingData = false;
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    getOwner() {
      return this.sesion.role === this.sesion.account_type.type
        ? this.sesion.id
        : this.sesion.account_type.owner;
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The text has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The text couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    async sendEmailConfirmationToCostumer(partnerId, email) {
      try {
        this.setLoad(true);
        let { data } = await CustomersAPI.sendEmailToConfirmAccount(
          partnerId,
          email,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The email has been send",
            icon: "flaticon-remove"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The email can't be send!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async sendConfirmation() {
      if (this.customer.type !== "guest") {
        let { value } = await Swal.fire({
          title: "Account Confirmation Email",
          html:
            "Are you sure you want to <strong>Send</strong> an account confirmation email?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",

          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          await this.sendEmailConfirmationToCostumer(
            this.partnerId,
            this.customer.email
          );
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Guest users are not allowed to login",
          icon: "flaticon-warning-1"
        });
      }
    },
    async sendEmailToRecoverPassword(partnerId, email) {
      try {
        this.setLoad(true);
        let { data } = await CustomersAPI.sendEmailToRecoverPassword(
          partnerId,
          email,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The email has been sent",
            icon: "flaticon-remove"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The email can't be send!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async sendEmailPassword() {
      if (this.customer.type !== "guest") {
        let { value } = await Swal.fire({
          title: "Password Recovery Email",
          html:
            "Are you sure you want to <strong>send</strong> the password recovery email?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",

          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          await this.sendEmailToRecoverPassword(
            this.partnerId,
            this.customer.email
          );
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Guest users are not allowed to login",
          icon: "flaticon-warning-1"
        });
      }
    },
    isInCustomerModule(modules = []) {
      if (!(modules.indexOf("customers") > -1)) {
        this.setCustomerSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    readFile: async function(event) {
      const [file] = event.target.files;
      if (file.size > 500 * 500) {
        event.preventDefault();
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
          icon: "flaticon-remove"
        });
        this.clearfile();
      } else {
        let fileData = FileService.generateResourceData(
          "/users/avatars",
          file.name
        );
        let queryString = FileService.buildQueryString(fileData);
        let urlFile = await FileService.uploadResource(file, queryString);
        if (urlFile) {
          this.customer.url_picture = urlFile;
          this.picture = urlFile;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
            icon: "flaticon-remove"
          });
        }
      }
    },
    clearfile() {
      this.customer.url_picture = "";
      this.picture = "";
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    searchCountry(value) {
      if (value !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.optionsCountries = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
          });
        }, 100);
      } else {
        this.optionsCountries = [];
      }
    },
    phoneInput(payload) {
      let result = payload;
      if (result.isValid) {
        this.customer.phone = result.number.e164;
      } else {
        this.customer.phone = "";
      }
    },
    validatePassword(password) {
      if (password.$error) {
        if (!password.minLength) {
          return `Password must have at least ${password.$params.minLength.min} letters`;
        } else if (password.required && password.$model.length < 1) {
          return `Password is required`;
        } else {
          return "Invalid password";
        }
      } else {
        return "";
      }
    },
    validateMarkup(value) {
      if (parseFloat(value) < 0) {
        this.customer.mark_up = 0;
      }
    },
    autogeneratePass() {
      var password = generator.generate({
        length: 8,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true
      });
      this.customer.password = password;
      this.repeatPassword = password;
    },
    seePassword() {
      this.typePassword = this.typePassword == "password" ? "text" : "password";
    },
    async savePartner(route = null) {
      try {
        if (!this.$v.customer.$invalid && !this.$v.repeatPassword.$invalid) {
          var customer = lodash.cloneDeep(this.customer);
          customer.full_name = `${customer.first_name} ${customer.last_name}`;
          customer.email = customer.email.toLowerCase();
          await this.updatePartnerById(this.$route.params.id, customer, route);
        } else {
          this.$v.customer.$touch();
          this.$v.repeatPassword.$touch();
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updatePartnerById(partnerId, partner, route = null) {
      try {
        this.setLoad(true);
        let { data } = await PartnersAPI.updatePartnerById(
          partnerId,
          partner,
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (data.data !== null) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Partner has been Saved",
            icon: "flaticon-check-3"
          });
          if (route) {
            this.$router.push(route);
          } else {
            this.mode = "view";
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "There was an error saving the Partner, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the Partner, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    openPaymentMethodModal() {
      this.showPaymentMethodModal = true;
    },
    closePaymentMethodModal() {
      this.showPaymentMethodModal = false;
      this.paymentMethodIndex = 0;
      this.paymentMethodType = "create";
      this.paymentMethod = null;
    },
    createPaymentMethod() {
      this.paymentMethodIndex = 0;
      this.paymentMethodType = "create";
      this.paymentMethod = null;
      this.openPaymentMethodModal();
    },
    async addPaymentMethod(paymentMethod) {
      if (this.paymentMethods.length === 0) {
        paymentMethod.default = true;
        this.paymentMethods.push(paymentMethod);
      } else {
        this.paymentMethods.push(paymentMethod);
      }
      await this.updatePaymentMethodByPartnerId(
        this.partnerId,
        { payment_methods: this.paymentMethods },
        "The Payment Method has been Added"
      );
      this.paymentMethodsOptions = this.paymentMethods;
    },
    async makePaymentMethodAsDefault(paymentMethodIndex) {
      this.paymentMethods.forEach((paymentMethod, index) => {
        paymentMethod.default = index === paymentMethodIndex;
      });
      await this.updatePaymentMethodByPartnerId(
        this.partnerId,
        { payment_methods: this.paymentMethods },
        "The Payment Method has been Updated"
      );
      this.paymentMethodsOptions = this.moveElementToFirst(this.paymentMethods);
    },
    async deletePaymentMethod(index) {
      let { value } = await Swal.fire({
        title: "Delete Payment Method",
        text: "Are you sure do you want to delete this Payment Method?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.paymentMethods.splice(index, 1);
        if (this.paymentMethods.length === 1) {
          this.paymentMethods[0].default = true;
        }
        await this.updatePaymentMethodByPartnerId(
          this.partnerId,
          { payment_methods: this.paymentMethods },
          "The Payment Method has been Deleted"
        );
        this.paymentMethodsOptions = this.paymentMethods;
      }
    },
    editPaymentMethodByIndex(option, index) {
      this.paymentMethodIndex = index;
      this.paymentMethodType = "edit";
      this.paymentMethod = option;
      this.openPaymentMethodModal();
    },
    async editPaymentMethod(paymentMethod) {
      if (paymentMethod) {
        this.paymentMethods.splice(this.paymentMethodIndex, 1, paymentMethod);
      }
      await this.updatePaymentMethodByPartnerId(
        this.partnerId,
        { payment_methods: this.paymentMethods },
        "The Payment Method has been Updated"
      );
      this.paymentMethodsOptions = this.paymentMethods;
      this.paymentMethodIndex = 0;
      this.paymentMethodType = "create";
      this.paymentMethod = null;
    },
    getCurrencyName(currencyCode) {
      if (currencyCode === "USD") {
        return "US Dollar";
      } else if (currencyCode === "EUR") {
        return "Euro";
      } else if (currencyCode === "GBP") {
        return "British Pound";
      } else if (currencyCode === "CHF") {
        return "Swiss Franc";
      } else if (currencyCode === "DKK") {
        return "Denmark Krone";
      } else if (currencyCode === "SEK") {
        return "Swedish Krona";
      } else if (currencyCode === "NOK") {
        return "Norwegian Krone";
      } else if (currencyCode === "ISK") {
        return "Icelandic Króna";
      } else if (currencyCode === "AED") {
        return "United Arab Emirates Dirham";
      }
    },
    async getPartnersOptions() {
      try {
        let { data } = await PartnersAPI.getPartnersOptions(this.sesion.token);
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    selectPartnerType(value) {
      this.customer.type = value;
    },
    getEmailValidationMessage(email) {
      if (email.$error) {
        if (!email.required) {
          return "Enter a valid email";
        } else if (!email.email) {
          return "Email is invalid";
        } else if (!email.customValidator) {
          return "Email is already used.";
        }
      } else {
        return "";
      }
    },
    async verifyEmailCustomer(email) {
      try {
        if (email) {
          let { data } = await AuthAPI.checkUniqueEmail(email.toLowerCase());
          if (data.status) {
            return !data.data.status;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    validateEmail(email) {
      return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
    },
    changeTabActive(tabActive) {
      this.tabActive = tabActive;
    },
    changeLimit(limit) {
      if (limit) {
        let currentCreditLimit = parseInt(limit);
        if (currentCreditLimit <= this.pendingPayment) {
          this.customer.credit.available = 0;
        } else {
          if (currentCreditLimit > this.oldCreditLimit) {
            if (this.customer.credit.available === 0) {
              let creditAvailable =
                currentCreditLimit - (this.creditLimit - this.creditAvailable);

              this.customer.credit.available = parseFloat(
                creditAvailable.toFixed(2)
              );
            } else {
              let creditAvailable =
                this.customer.credit.available +
                (currentCreditLimit - this.oldCreditLimit);

              this.customer.credit.available = parseFloat(
                creditAvailable.toFixed(2)
              );
            }
          } else {
            let creditAvailable =
              this.customer.credit.available -
              (this.oldCreditLimit - currentCreditLimit);

            this.customer.credit.available = parseFloat(
              creditAvailable.toFixed(2)
            );
          }
        }
        this.oldCreditLimit = parseInt(limit);
      } else {
        this.oldCreditLimit = 0;
        this.customer.credit.available = 0;
      }
    },
    changeStatusLimit(status) {
      if (!status) {
        this.customer.credit.limit = this.creditLimit;
        this.oldCreditLimit = this.customer.credit.limit;
        this.customer.credit.available = this.creditAvailable;
      }
    },
    isInPartnerModule(modules = []) {
      if (!(modules.indexOf("partners") > -1)) {
        this.setPartnerSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async detectChanges(from, to, next) {
      let isEqual = lodash.isEqual(this.customer, this.customerCopy);
      if (!isEqual && !this.saved && this.canUserUpdate) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The Partner has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.savePartner(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    getAddreess(address, city, post_code, country) {
      return address + ", " + city + ", " + post_code + ", " + country;
    },
    async updatePaymentMethodByPartnerId(
      partnerId,
      paymentMethods,
      successMessage
    ) {
      try {
        let { data } = await PartnersAPI.updateAnyAttributeById(
          partnerId,
          paymentMethods,
          this.sesion.token
        );
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: successMessage,
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "There was an error saving the Payment Method, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "There was an error saving the Payment Method, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    moveElementToFirst(paymentMethods = []) {
      let index = paymentMethods
        .map(paymentMethod => paymentMethod.default)
        .indexOf(true);
      if (index > -1) {
        let paymentMethod = paymentMethods[index];
        paymentMethods.splice(index, 1);
        paymentMethods.unshift(paymentMethod);
      }
      return paymentMethods;
    },
    openModalChange() {
      this.showChangeModal = true;
    },
    closeChangeModal(status) {
      this.showChangeModal = status;
    },
    async onPartnerChange(status) {
      if (status) {
        await this.getCustomer(this.partnerId);
        this.agencies = await this.getPartnersOptions();
      }
    },
    changeCommercialTerms(value) {
      if (value === "net_price") {
        this.customer.commission = 0;
      } else {
        this.customer.commission =
          this.lastCommission === 0 ? 10 : this.lastCommission;
      }
    },
    changeCommision(value) {
      this.lastCommission = parseInt(value);
    },
    controllingChanges(event) {
      var channel = this.pusher.subscribe("rhombuss");
      channel.bind(event, async data => {
        let { customerId } = data.customer;
        if ([this.partnerId].includes(customerId)) {
          await this.getCustomer(this.partnerId, false);
        }
      });
    },
    changeStatusCredit(value) {
      this.hasCredit = value;
    },
    async uploadLogos(logo) {
      try {
        let [file] = await this.uploaderOpen();
        if (file) {
          if (logo === "default") {
            this.customer.settings.brand.logos.default = file.fileUrl;
          } else if (logo === "favicon") {
            this.customer.settings.brand.logos.favicon = file.fileUrl;
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async uploaderOpen() {
      return await uploader.open({
        maxFileCount: 1,
        maxFileSizeBytes: 2000000,
        mimeTypes: ["image/png"],
        multi: false,
        styles: {
          colors: {
            active: "#528fff",
            error: "#d23f4d",
            primary: "#4b56a6"
          }
        },
        editor: {
          images: {
            crop: false,
            preview: true
          }
        },
        path: {
          folderPath: "/users/partners/brand",
          folderPathVariablesEnabled: true
        }
      });
    },
    removeLogo(logo) {
      if (logo === "default") {
        this.customer.settings.brand.logos.default = "";
      } else if (logo === "favicon") {
        this.customer.settings.brand.logos.favicon = "";
      }
    },
    getTextColorButtonBrand() {
      this.customer.settings.brand.colors.buttonText = this.getContrastColor(
        this.customer.settings.brand.colors.primary
      );
      this.getBrandTheme();
    },
    hexToRgb(hex) {
      const bigint = parseInt(hex.slice(1), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return { r, g, b };
    },
    getContrastColor(hex) {
      const { r, g, b } = this.hexToRgb(hex);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 128 ? "#000000" : "#ffffff";
    },
    getBrandTheme() {
      if (this.customer.settings.brand.colors.inTheme) {
        this.customer.settings.brand.theme.color = this.customer.settings.brand.colors.primary;
        this.customer.settings.brand.theme.buttonText = this.getContrastColor(
          this.customer.settings.brand.colors.primary
        );
      } else {
        this.customer.settings.brand.theme.color = "#4b56a6";
        this.customer.settings.brand.theme.buttonText = "#FFFFFF";
      }
    },
    isConfigurationAllowed(partnerType, permissions) {
      if (partnerType === "travel_agency") {
        return true;
      } else {
        return permissions;
      }
    },
    isSettingsAttributeRequired(
      partnerType,
      partnerSettings,
      associationSettings = null
    ) {
      if (partnerType === "travel_agency") {
        return partnerSettings.permissions.brand ? true : false;
      } else {
        if (associationSettings) {
          if (associationSettings.permissions.notifications) {
            return partnerSettings.permissions.notifications ? true : false;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    },
    getUserType(type) {
      if (type === "travel_agency") {
        return "Travel Agency";
      } else {
        return "Agent";
      }
    },
    getCommercialTerms(type) {
      if (type === "commission") {
        return "Commission";
      } else {
        return "Net Price";
      }
    },
    getGender(gender) {
      if (gender === "male") {
        return "Male";
      } else if (gender == "female") {
        return "Female";
      } else {
        return "Other";
      }
    },
    getPaymentMethodType(type) {
      if (type === "paypal") {
        return "Paypal";
      } else {
        return "Bank Account";
      }
    },
    getTransferType(type) {
      if (type === "ach") {
        return "ACH";
      } else if (type === "wire") {
        return "WIRE";
      } else if (type === "swift") {
        return "SWIFT";
      } else if (type === "transfer_eur") {
        return "Transfer to EUR";
      } else if (type === "transfer_gbp") {
        return "Transfer to GBP";
      }
    },
    getTransferTypeMin(type) {
      if (type === "ach") {
        return "ACH";
      } else if (type === "wire") {
        return "WIRE";
      } else if (type === "swift") {
        return "SWIFT";
      } else if (type === "transfer_eur") {
        return "EUR";
      } else if (type === "transfer_gbp") {
        return "GBP";
      }
    },
    getAccountType(type) {
      if (type === "savings") {
        return "Savings";
      } else if (type === "checking") {
        return "Checking";
      }
    },
    changeCompanyName(value) {
      this.customer.settings.entityDetails.company.name = value;
    },
    changeVATNumber(value) {
      this.customer.settings.entityDetails.company.vatnumber = value;
    },
    changeCompanyEmail(value) {
      this.customer.settings.entityDetails.company.email = value;
    },
    changePermissions(value) {
      if (!value) {
        this.customer.settings.permissions.notifications = false;
      }
    },
    displayBrandTab(partnerType, permissions) {
      if (partnerType === "travel_agency" && permissions.brand) {
        return true;
      } else {
        return false;
      }
    },
    displayNotificationTab(partnerType, permissions) {
      if (partnerType === "travel_agency") {
        return permissions.brand ? true : false;
      } else {
        return permissions.notifications ? true : false;
      }
    },
    createReferenceCode(prefix) {
      if (prefix) {
        return slugify(`${prefix}-${randomUUID()}`, {
          lower: true,
          strict: true
        });
      } else {
        return slugify(randomUUID(), {
          lower: true,
          strict: true
        });
      }
    },
    async generateReferenceCode() {
      if (this.customer.referenceCode) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Referral ID has already been generated",
          icon: "flaticon-remove"
        });
        return;
      }

      let referenceCode = this.createReferenceCode(this.customer.last_name);
      if (referenceCode) {
        await this.updateAgentReferenceCode(this.partnerId, referenceCode);
      }
      return;
    },
    async updateAgentReferenceCode(partnerId, referenceCode) {
      try {
        let { data } = await AgentsAPI.updatePartnerReferenceCode(
          partnerId,
          referenceCode,
          this.sesion.token
        );
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Referral ID has been updated",
            icon: "flaticon-check-3"
          });
          this.referenceCode = referenceCode;
          this.customer.referenceCode = referenceCode;
          this.customerCopy = lodash.cloneDeep(this.customer);
          return;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
          return;
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
        return;
      }
    },
    ...mapMutations(["setLoad", "setItemsBread", "setPartnerSearchCriteria"]),
    ...mapActions(["getAgents", "getLimit"])
  },
  computed: {
    ...mapGetters([
      "countries",
      "sesion",
      "userRole",
      "load",
      "agents",
      "paginationLimit"
    ]),
    canUserUpdate() {
      return isUserAuthorized("PARTNERS", this.userRole, "UPDATE");
    },
    canUserCreate() {
      return isUserAuthorized("PARTNERS", this.userRole, "CREATE");
    },
    canUserResendEmail() {
      return isUserAuthorized("PARTNERS", this.userRole, "RESEND_EMAIL");
    }
  },
  validations() {
    return {
      customer: {
        first_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        last_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        company_name: {
          required: requiredIf(function(value) {
            return "travel_agency" === this.partnerType;
          }),
          minLength: minLength(3),
          maxLength: maxLength(45)
        },
        legal_name: {
          minLength: minLength(3),
          maxLength: maxLength(45)
        },
        iata_code: {
          minLength: minLength(5),
          maxLength: maxLength(25)
        },
        vat_number: {
          minLength: minLength(5),
          maxLength: maxLength(25)
        },
        mark_up: {
          numeric,
          decimal,
          between: between(0, 100),
          minLength: minLength(1),
          maxLength: maxLength(2)
        },
        email: {
          required,
          email,
          customValidator: async function(value) {
            if (this.validateEmail(value)) {
              if (this.lastEmail !== value) {
                return await this.verifyEmailCustomer(value);
              } else {
                return true;
              }
            } else {
              return false;
            }
          }
        },
        password: {
          minLength: minLength(8),
          strongPassword(password) {
            if (password === "") {
              return true;
            } else {
              return (
                /[a-z]/.test(password) && // checks for a-z
                /[A-Z]/.test(password) && // checks for A-Z
                /[0-9]/.test(password) && // checks for 0-9
                /\W|_/.test(password) && // checks for special char
                password.length >= 8
              );
            }
          }
        },
        gender: {
          required: requiredIf(function(value) {
            return this.partnerType === "customer";
          })
        },
        type_charge: {
          required: requiredIf(function(value) {
            return this.partnerType === "travel_agency";
          })
        },
        phone: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(25)
        },
        country: {
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        city: {
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        state: {
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        zip_code: {
          minLength: minLength(4),
          maxLength: maxLength(10)
        },
        street: {
          minLength: minLength(5),
          maxLength: maxLength(100)
        },
        type: {
          required
        },
        notes: {
          maxLength: maxLength(200)
        },
        credit: {
          status: {
            required: requiredIf(function(value) {
              return (
                this.customer.type === "travel_agency" &&
                this.customer.credit.status
              );
            })
          },
          limit: {
            required: requiredIf(function(value) {
              return (
                this.customer.type === "travel_agency" &&
                this.customer.credit.status
              );
            }),
            minValue: 0
          },
          available: {
            required: requiredIf(function(value) {
              return (
                this.customer.type === "travel_agency" &&
                this.customer.credit.status
              );
            })
          }
        },
        currency: {
          required: requiredIf(function(value) {
            return this.customer.type === "travel_agency";
          })
        },
        association: {
          required: requiredIf(function(value) {
            return this.customer.type !== "travel_agency";
          })
        },
        commission: {
          numeric,
          decimal,
          between: between(0, 100)
        },
        settings: {
          brand: {
            logos: {
              default: {
                required: requiredIf(function(value) {
                  return this.isSettingsAttributeRequired(
                    this.customer.type,
                    this.customer.settings,
                    this.association ? this.association.settings : null
                  );
                })
              }
            },
            colors: {
              primary: {
                required: requiredIf(function(value) {
                  return this.isSettingsAttributeRequired(
                    this.customer.type,
                    this.customer.settings,
                    this.association ? this.association.settings : null
                  );
                })
              },
              buttonText: {
                required: requiredIf(function(value) {
                  return this.isSettingsAttributeRequired(
                    this.customer.type,
                    this.customer.settings,
                    this.association ? this.association.settings : null
                  );
                })
              }
            },
            theme: {
              color: {
                required: requiredIf(function(value) {
                  return this.isSettingsAttributeRequired(
                    this.customer.type,
                    this.customer.settings,
                    this.association ? this.association.settings : null
                  );
                })
              },
              buttonText: {
                required: requiredIf(function(value) {
                  return this.isSettingsAttributeRequired(
                    this.customer.type,
                    this.customer.settings,
                    this.association ? this.association.settings : null
                  );
                })
              }
            }
          },
          entityDetails: {
            contact: {
              phoneNumber: {
                required: false,
                minLength: minLength(7),
                maxLength: maxLength(25)
              },
              email: {
                required: false,
                email
              }
            },
            pages: {
              contact: {
                required: false,
                maxLength: maxLength(1000)
              }
            },
            importantNote: {
              minLength: minLength(100),
              maxlength: maxLength(5000)
            }
          },
          socialmedia: {
            facebook: {
              url
            },
            twitter: {
              url
            },
            instagram: {
              url
            },
            linkedin: {
              url
            }
          }
        }
      },
      repeatPassword: {
        sameAsPassword: sameAs(function() {
          return this.customer.password;
        })
      }
    };
  },
  destroyed() {
    if (this.pusher !== null) {
      this.pusher.disconnect();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInPartnerModule(to.meta.modules);
    this.detectChanges(from, to, next);
  },
  beforeRouteUpdate(to, from, next) {
    this.isInPartnerModule(to.meta.modules);
    this.detectChanges(from, to, next);
  }
};
</script>
